/* eslint-disable @typescript-eslint/no-misused-promises */
import { ActivatedChallengeLinkSet, Badge, BoundsPadding, ChallengeReward, ChallengeType, CircleDetails, CombineOperator, CreateAccountRequest, CreatePointRequest, CreateTopicRequest, CustomOverlay, CustomShape, DrawingMode, DrawnOverlay, FeatureType, GateType, GeoJsonGeometry, GetActivatedChallengeResponse, GetChallengeResponse, GetElectionResponse, GetPointResponse, GetPopUpResponse, IntegrationException, LatLng, Location, LoginOrigin, MapDrawer, MapPopUp, MapSetUpOptions, PendingVote, PopUpTrigger, SubTagSearchType, TagSearchType, TopLevelMarkerHolder, TopLevelShapeHolder, TopLevelTagSearchType } from '../types';
import { DEFAULT_EMAIL_COLLECTION_POPUP, MAP_STYLES_COLLECTION } from '../helpers/constants';
import { GoogleTagEvent, logWithAmplitude, logWithGoogleTag, logWithGoogleTagAndTopicOrganization } from '../helpers/api/api';
import { LitElement, css, html } from 'lit';
import { addBadgeToMarker, revertIconForMarker, setFocusIconForMarker, setHiddenIconForMarker } from '../helpers/markers';
import { addParameterToURL, debounce, delay, getFromLocalStorage, getMarkerElement, getMarkerPosition, getMarkerTitle, isDefined, isValidString, numberToPlaceValue, removeLocalStorage, removeParameterFromURL, replaceStateWithPageName, setLocalStorage, setMarkerClickable, setMarkerMap, show_confetti, undefinedIfEmpty, updateMarkerIcon, updateMarkerPosition, updateMarkerTitle, updateMarkerVisibility, updateMarkerZIndex } from '../helpers/utils';
import { addShapeToMap, createShapeHolderFromCustomShape, setShapeOptions } from '../helpers/shapes';
import { addTopicRender, createTopicRequestFromTopic } from '../helpers/api/topics-api';
import { categoryFilterFn, keywordSearchFn, pointSearch, tagsFilterFn } from '../helpers/filters';
import challengeData, { challengeTypeDisplayName } from'../helpers/state/challenge-data';
import { checkGeoTrigger, markPopupAsShown, selectStandalonePopup, trackPopupImpression } from '../helpers/standalone-popups-display';
import { createOverlayDiv, getBoundsForOverlay } from './admin/style/map-overlay-editor';
import { customElement, property, query, state } from 'lit/decorators';
import { detectMobileViewport, inIframe, inSmallScreen } from '../helpers/device';
import { electionNominationsAreHappening, electionVotingIsHappening, getElectionLeaders, isVoterEligible } from '../helpers/api/election-api';
import { fonts, palette } from '../style/variables';
import { saveEmail, setAccount } from '../helpers/api/account-api';

import { AddEditPointComponent } from './add-edit-point-component';
import { AddPointButton } from './add-point-button';
import { ChallengePage } from '../pages/challenge-page';
import { CheckinChallengeComponent } from './checkin-challenge-component';
import { Dialog } from '@material/mwc-dialog';
import { EditShapeModal } from './edit-shape-modal';
import { ElectionFormComponent } from './election-form-component';
import { EmailCaptureModal } from './email-capture-modal';
import { GOOGLE_KEY } from '../helpers/api/google-api';
import { GetRouteComponent } from './get-route-component';
import { Marker } from '@twitchaxorg/markerclusterer';
import { NominationComponent } from './nomination-component';
import { PaperInputElement } from '@polymer/paper-input/paper-input';
import { PointCardPagination } from './point-card-pagination';
import { PointDrawer } from './point-drawer';
import { SettingDrawer } from './mobile/setting-drawer';
import { StateController } from '../helpers/state/state-management/state-controller';
import accountInfo from '../helpers/state/account-info';
import drawingTool from '../helpers/state/drawing-tool';
import featuresInfo from '../helpers/state/features-info';
import { getMainPage } from '../helpers/page-name';
import { getSocialMediaImageForTopic } from '../helpers/files';
import { ifDefined } from 'lit/directives/if-defined';
import { openChatWindow } from '../helpers/intercom';
import organizationInfo from '../helpers/state/organization-info';
import pointCache from '../helpers/state/point-cache';
import { ref } from 'lit/directives/ref.js';
import { storeReferralFromUrl } from '../helpers/api/referral-api';
import topicData from '../helpers/state/topic-data';

@customElement('map-component')
export class MapComponent extends LitElement {
    static amplitude_callsite: string = 'Map Component';

    @query('#search')
    search!: PaperInputElement;

    @query('#shapeModalContent')
    shapeModalContent!: EditShapeModal;

    @query('#addPointButton')
    addPointButton!: AddPointButton;

    @query('#map')
    googleMapComponent!: HTMLElement | any;

    @query('#pointDrawer')
    pointDrawer?: PointDrawer;

    @query('#gptAddPointsModal')
    gptAddPointsModal!: Dialog;

    @query('#challengeModal')
    challengeModal!: Dialog;

    @query('#electionModal')
    electionModal!: Dialog;

    @query('#challengeDrawer')
    challengeDrawer?: SettingDrawer;

    @query('#signinModalComponent')
    signinModalComponent!: Dialog;

    @query('#pointCardPaginationEl')
    pointCardPaginationEl!: PointCardPagination;

    @query('#addToMapModal')
    addToMapModal!: Dialog;

    @query('#addToMapDrawer')
    addToMapDrawer?: SettingDrawer;

    @query('#electionForm')
    electionFormElement!: ElectionFormComponent;

    @query('#nominationForm')
    nominationComponent!: NominationComponent;

    @query('#challengeCheckIn')
    challengeCheckInElement!: CheckinChallengeComponent;

    @query('#emailCapturePopUp')
    emailCapturePopUpElement!: EmailCaptureModal;

    @query('#addPointElement')
    addPointElement!: AddEditPointComponent;

    @query('#editPointElement')
    editPointElement!: AddEditPointComponent;

    @query('#teamAccessComponent')
    teamAccessComponent!: Dialog;

    @query('#optimizedRouteComponent')
    optimizedRouteComponent!: GetRouteComponent;

    @query('#challengePageComponent')
    challengePageComponent?: ChallengePage;

    @property({ type: String })
    focused_point_id?: string;

    @property({ type: String })
    focused_challenge_location_id?: string;

    @property({ type: Object })
    focus_load_parameters?: MapSetUpOptions;

    @property({ type: Boolean })
    open_challenge_modal?: boolean;

    @property({ type: Boolean })
    isAdminPortalMobile = false;

    @property({ type: Boolean })
    showAddPointButton = false;

    @property({ type: Boolean })
    showOtherDrawerButton = false;

    @property({ type: Boolean })
    showDrawToolOptions = false;

    @property({ type: Boolean })
    showOverlayImageUpload = false;

    @property({ type: Boolean })
    isAdminPortalDesktop = false;

    @property({ type: Boolean })
    isDiscoveryView = false;

    @property({ type: Boolean })
    hideEmailCapturePopUp = false;

    @property({ type: Boolean })
    hideCategoriesandTags = false;

    @property({ type: Object })
    locationBeforeDrag?: Location;

    @property( { type: Boolean })
    hidePointCardPaginationOnLoad = false;

    @state()
    drawnOverlays: DrawnOverlay[] = [];

    @state()
    overlayEditCircle?: google.maps.Circle;

    @state()
    private lat: number = 0;

    @state()
    private lng: number = 0;

    @state()
    private zoom: number = 4;

    @state()
    private geolat?: number;

    @state()
    private geolng?: number;

    @state()
    mapMode = 'light';

    @state()
    is_map_locked = false;

    @state()
    isPrintView = false;

    @state()
    showMap = false;

    @state()
    showSetDefaultZoomCenter: boolean = false;

    @state()
    focusedMarker?: TopLevelMarkerHolder;

    @state()
    userSelectedLatLng?: Location; // this is used to pass into the edit point modal

    @state()
    foucsedShapeHolder?: TopLevelShapeHolder;

    @state()
    focusedPoint?: GetPointResponse; // this is the point that is focused on the map and is expanded in the point drawer

    @state()
    selectedPoints: GetPointResponse[] = [];

    @state()
    openParticipantProgressModal = false;

    @state()
    highlightedPoint?: GetPointResponse; // this is the first point in the point drawer - it is often the same as focusedPoint, but is not when a user clicks a card in point list

    @state()
    geoToggleImage = '/images/geoOff.png';

    @state()
    additionalMapOptions?: string = undefined;

    @state()
    pointListOpen: boolean = false;

    @state()
    createTopicRequest: CreateTopicRequest = createTopicRequestFromTopic(topicData.topic);

    @state()
    currentPopUp?: GetPopUpResponse;

    @state()
    get pointUrl() {
        if (isDefined(this.focusedPoint)) {
            return `${topicData.publicShareLink.split('?')[0]}?point_id=${
                this.focusedPoint?._id.$oid
            }`;
        }
        return '';
    }

    @state()
    open_checkin_challenge: boolean = false;

    @state()
    open_election: boolean = false;

    @state()
    pendingVote?: PendingVote;

    @state()
    pendingCheckinPoint?: GetPointResponse;

    @state()
    bottomDrawerHeight: number = 0;

    @state()
    isInStaticMapMode: boolean = false;

    @state()
    showMapStyleEditor: boolean = false;

    @state()
    backgroundImage?: string;

    @state()
    showEmailConfirm: boolean = false;

    @state()
    election?: GetElectionResponse;

    @state()
    challenge?: GetChallengeResponse;

    @state()
    activatedChallenge?: GetActivatedChallengeResponse;

    @state()
    hasActivatedChallenge: boolean = false;

    @state()
    newRewards: ChallengeReward[] = [];

    @state()
    currentRewards: ChallengeReward[] = [];

    @state()
    isEnabledDrawShape: boolean = false;

    @state()
    drawingMode?: DrawingMode;

    @state()
    isLoadingChallenge: boolean = false;

    @state()
    isLoadingElection: boolean = false;

    @state()
    _feature?: google.maps.Data.Feature;

    @state()
    challengeIsHappening: boolean = false;

    @state()
    electionIsHappening: boolean = false;

    @state()
    showElectionLeaders: boolean = false;

    @state()
    isUserPreview: boolean = false;

    @state()
    mobilePreview: boolean = false;

    @state()
    advancedFilterOn = false;

    @state()
    selectedCategories: string[] = [];

    @state()
    selectedTopTags: TopLevelTagSearchType[] = [];

    @state()
    selectedTags: TagSearchType = {
        operator: CombineOperator.And,
        tags: [],
    };

    @state()
    selectedSubTags: SubTagSearchType[] = [];

    @state()
    keywordsList: string[] = [];

    @state()
    multiSelectionEnabled: boolean = false;

    // used for screenshots
    @state()
    standaloneMapMode: boolean = false;

    @state()
    challengeModalTitle: string = this.challenge?.name ?? '';

    @state()
    showNearbyPlacesSearchModal: boolean = false;

    @state()
    nearbySearchCenter?: LatLng;

    @state()
    nearbySearchRadius?: number = 500;

    @state()
    nearbySearchResults?: CreatePointRequest[];

    @state()
    nearbyPointsSearchCircle?: google.maps.Circle;

    @state()
    focusedNearbySearchResult?: CreatePointRequest;

    @state()
    nearbySearchMarkers: Marker[] = [];

    @state()
    drawingIsActive: boolean = false;

    @state()
    mapDrawer?: MapDrawer;

    @state()
    mapPopUp?: MapPopUp;

    @state()
    showHomeScreenVideo = false;

    @state()
    isCreating: boolean = false;

    @state()
    askForShapeType: boolean = false;

    @state()
    isFullScreen: boolean = false;

    @state()
    drawingCircle?: boolean = false;

    @state()
    geolocationMarker?: Marker;

    private readonly addFeatureListener?: google.maps.MapsEventListener;
    private readonly clickListener?: google.maps.MapsEventListener;

    creator_profile_id?: string;

    private readonly bindPointCacheState = new StateController(this, pointCache);
    private readonly bindTopicState = new StateController(this, topicData);
    private readonly bindAccountState = new StateController(this, accountInfo);
    private readonly bindChallengeState = new StateController(this, challengeData);
    private readonly bindFeaturesState = new StateController(this, featuresInfo);
    private readonly bindOrganizationState = new StateController(this, organizationInfo);
    private readonly bindDrawingToolState = new StateController(this, drawingTool);

    private geolocationLoopStarted = false;
    private mapReady = false;
    private asyncRecenter = false;

    constructor() {
        super();

        // Set the map mode from local storage.
        const mapMode = getFromLocalStorage('mapMode');
        if (mapMode) {
            this.mapMode = mapMode;
        }
    }

    get isMobile() {
        return detectMobileViewport(this.mobilePreview);
    }

    async setMapDrawer(drawer: MapDrawer) {
        // force a refresh of the add or edit point drawers
        if (this.mapDrawer === drawer && this.mapDrawer !== MapDrawer.AddPoint && this.mapDrawer !== MapDrawer.EditPoint) {
            return;
        };
        if (isDefined(this.mapDrawer)) {
            await this.closeMapDrawer();
            await delay(500);
        } else {
            this.dispatchEvent(new CustomEvent('drawer-changed'));
        }
        this.mapDrawer = drawer;
        this.requestUpdate();
    }

    async openEmailCaputreModal() {
        await this.setMapDrawer(MapDrawer.EmailCaptureMobile);
    }

    async openPostSubmissionPopUp() {
        if(detectMobileViewport(this.mobilePreview)) {
            await this.setMapDrawer(MapDrawer.PostSubmissionPopUpMobile);
        } else {
            await this.setMapPopUp(MapPopUp.PostSubmissionPopUpDesktop);
        }
    }


    /**
     * Display a standalone popup with proper tracking and cooldown management
     */
    async displayStandalonePopup(popup: GetPopUpResponse) {
        // Check geo-trigger if present
        if (isDefined(popup.geo_trigger)) {
            const isWithinGeo = await checkGeoTrigger(popup.geo_trigger, this.geolat, this.geolng);
            if (!isWithinGeo) {
                return;
            }
        }

        // Track impression, set cooldown, and mark as shown
        await trackPopupImpression(popup);
        markPopupAsShown(popup);

        // Display the popup using email-capture-modal
        // Temporarily set popup properties on the email-capture-modal
        // This is a workaround until we have a dedicated standalone popup component
        await this.openEmailCaputreModal();
        await delay(100);
        if (isDefined(this.emailCapturePopUpElement)) {
            this.currentPopUp = popup;
        }
    }


    async setMapPopUp(popup: MapPopUp) {
        if (isDefined(this.mapPopUp)) {
            await this.closeMapPopUp();
            await delay(500);
        } else {
            this.dispatchEvent(new CustomEvent('popup-changed'));
        }
        this.mapPopUp = popup;
        this.requestUpdate();
    }

    async closeMapDrawer() {
        if (isDefined(this.mapDrawer)) {
            await delay(500);
        }
        this.mapDrawer = undefined;
        this.dispatchEvent(new CustomEvent('drawer-changed'));
    }

    async closeMapPopUp() {
        this.mapPopUp = undefined;
        this.dispatchEvent(new CustomEvent('popup-changed'));
    }

    async unlockMap() {
        this.is_map_locked = false;
        this.isInStaticMapMode = false;
        this.addTopicRender();
    }

    async firstUpdated() {
        // We want to restrict live map loads for viral embedded maps.
        const is_in_iframe = inIframe();
        const is_map_under_view_block_threshold = (topicData.topic?.statistics?.approximate_topic_seven_day_views ?? 0) < 200 && (topicData.topic?.statistics?.approximate_point_count ?? 25) < 30;
        const can_access_dynamic_map = is_map_under_view_block_threshold || featuresInfo.publiclyViewableEnabled;
        // if url contains proxi.co (not map.proxi.co) then we are using it for marketing
        const parent_url = inIframe() ? document.referrer : window.location.hostname.toLowerCase();
        let marketing_override = false;
        if (isValidString(parent_url) && parent_url.includes('proxi.co') && !parent_url.includes('map.proxi.co')) {
            marketing_override = true;
        }
        const is_in_load_anyway_mode = this.isAdminPortalDesktop || this.isAdminPortalMobile || this.isDiscoveryView || this.standaloneMapMode || marketing_override;
        this.is_map_locked = !can_access_dynamic_map && !is_in_load_anyway_mode;
        // Free and lapsed workspaces pay for the map only when a visitor engages, whatever the point count.
        const require_map_click = ((topicData.topic?.statistics?.approximate_topic_seven_day_views ?? 0) > 1000 && is_in_iframe)
            || (!featuresInfo.publiclyViewableEnabled && !is_in_load_anyway_mode);
        if (this.is_map_locked || require_map_click) {

            // some old maps dont have a standalone_map_link and thus no background image to display
            if (isDefined(topicData.topic?.standalone_map_link) && topicData.topic?.standalone_map_link !== '') {

                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.backgroundImage = getSocialMediaImageForTopic(topicData.topic!, this.focus_load_parameters);
                this.isInStaticMapMode = true;

                const showMap = () => {
                    this.isInStaticMapMode = false;
                    this.addTopicRender();
                    window.document.removeEventListener('click', clickListener);
                    if (featuresInfo.headerLogoEnabled) {
                        window.document.removeEventListener('mouseover', hoverListener);
                        window.document.removeEventListener('touchstart', touchStartListener);
                    }
                };

                const clickListener = (e: MouseEvent) => showMap();
                const hoverListener = (e: MouseEvent) => showMap();
                const touchStartListener = (e: TouchEvent) => showMap();

                if (!this.is_map_locked) {
                    window.document.addEventListener('click', clickListener);

                    // add hover listener for desktop and touchstart for mobile to people who actually pay us
                    // require a full click on those who don't pay us or have a lot of views
                    if (featuresInfo.publiclyViewableEnabled && !require_map_click) {
                        window.document.addEventListener('mouseover', hoverListener);
                        window.document.addEventListener('touchstart', touchStartListener);
                    }
                }
            }
        } else {
            if (!this.isAdminPortalDesktop && !this.isAdminPortalMobile) {
                this.addTopicRender();
            }
        }

        if (!this.mapReady) {
            await this.setMapOptionsAndShowMap();
        }

        // Load and display standalone popups
        if (topicData.topic?._id?.$oid && !topicData.isWriter) {
            await topicData.loadStandalonePopups(topicData.topic._id.$oid);

            // If any popup has a geo-trigger, request location early
            const hasGeoPopups = topicData.standalonePopups.some(p => p.geo_trigger);
            if (hasGeoPopups && !this.geolocationLoopStarted) {
                this.startGeolocationLoop();
            }

            // Select best popup across both trigger types, picking highest priority
            const onMapLoadPopup = selectStandalonePopup(PopUpTrigger.OnMapLoad);
            const logicBasedPopup = selectStandalonePopup(PopUpTrigger.LogicBased);
            let popupToShow = onMapLoadPopup;
            if (!isDefined(popupToShow)) {
                popupToShow = logicBasedPopup;
            } else if (isDefined(logicBasedPopup) && logicBasedPopup.priority > popupToShow.priority) {
                popupToShow = logicBasedPopup;
            }

            if (isDefined(popupToShow)) {
                const delay = 1000 * (popupToShow.display_delay_seconds ?? 0);
                const popup = popupToShow;
                setTimeout(async () => {
                    if (this.mapDrawer) {
                        return;
                    }
                    await this.displayStandalonePopup(popup);
                }, delay);
            }
        }

        const signin_modal_status = getFromLocalStorage('signin_modal');
        this.showEmailConfirm = false;

        if (isDefined(signin_modal_status)) {
            if (accountInfo.isAuthenticated) {
                removeLocalStorage('signin_modal');
            } else {
                const status = JSON.parse(signin_modal_status);
                if (isDefined(status.pendingCheckinPointId)) {
                    this.pendingCheckinPoint = pointCache.allPoints.find((p) => p._id.$oid === status.pendingCheckinPointId);
                }
                this.showEmailConfirm = true;
                await this.openChallengeModal();
            }
        }

        if (this.focus_load_parameters !== undefined) {
            if (this.focus_load_parameters.center_lat !== undefined) {
                this.lat = this.focus_load_parameters.center_lat;
            }
            if (this.focus_load_parameters.center_lng !== undefined) {
                this.lng = this.focus_load_parameters.center_lng;
            }
            if (this.focus_load_parameters.zoom !== undefined) {
                this.zoom = this.focus_load_parameters.zoom;
            }
            if (this.focus_load_parameters.focusPointId !== undefined) {
                this.focused_point_id = this.focus_load_parameters.focusPointId;
            }

            if (this.focus_load_parameters.selectedCategories !== undefined) {
                this.filterCategoriesOnLoad(this.focus_load_parameters.selectedCategories);
            }

            if (this.focus_load_parameters.selectedTags !== undefined) {
                this.filterTagsOnLoad(this.focus_load_parameters.selectedTags);
            }

            if (this.focus_load_parameters.focusChallengeLocationId !== undefined) {
                const challenge = challengeData.challenge;
                if (challenge && challenge?.locations?.length > 0) {
                    this.focused_challenge_location_id = this.focus_load_parameters.focusChallengeLocationId;
                }
            }
        }

        this.style.setProperty('font-family', topicData.topic?.custom_font ?? fonts.mainFont);
        this.style.setProperty('--mdc-typography-button-font-family', topicData.topic?.custom_font ?? fonts.mainFont);
        this.style.setProperty('--btn-font-family', topicData.topic?.custom_font ?? fonts.mainFont);

        topicData.mapComponent = this;
    }

    async updated(changedProperties: Map<string | number | symbol, unknown>): Promise<void> {
        if (
            changedProperties.has('lat') ||
            changedProperties.has('lng') ||
            changedProperties.has('zoom')
        ) {
            if (this.lat !== this.geolat && this.lng !== this.geolng) {
                this.geoToggleImage = '/images/geoOff.png';
            }
            this.latLongZoomChanged();
        }
        if (
            (changedProperties.has('geolat') || changedProperties.has('geolng'))
        ) {
            if (this.asyncRecenter) {
                await this.updateCenterToGeolocation();
                this.asyncRecenter = false;
            }
            this.addOrUpdateLocationIcon();
        }
        if (changedProperties.has('challengeIsHappening')) {
            if (this.challengeIsHappening) {
                // wait up to 5 seconds for the challenge data to be ready
                let count = 0;
                while (!challengeData.isReady && count < 10) {
                    await delay(500);
                    count++;
                }
                if (!isDefined(challengeData.activatedChallengeId)) {
                    // show challenge pop up if the user is not registered for the challenge already
                    this.challengePopUp();
                }
            }
        }

        if (changedProperties.has('electionIsHappening')) {
            if (this.electionIsHappening) {
                await this.electionPopUp();
            }
        }

        if (changedProperties.has('showElectionLeaders')) {
            // wait until point cache is ready. Up to 20 seconds
            let count = 0;
            while ((!pointCache.isReady || pointCache.allMarkers.length === 0) && count < 40) {
                await delay(500);
                count++;
            }

            if (this.showElectionLeaders && topicData.topicId) {
                const leaders = await getElectionLeaders(this.election?._id?.$oid ?? topicData.allElections[0]?._id.$oid ?? '', topicData.topicId, topicData.topicKey);
                // add badge to the leader icons
                for (const category of leaders) {
                    const leaders = category.leaders.slice(0, 3);
                    for (const leader of leaders) {
                        const marker = pointCache.getMarker(leader.point_id);
                        const index = category.leaders.indexOf(leader);
                        const icon = index === 0 ? '/images/ic_first_place.png' : index === 1 ? '/images/ic_second_place.png' : index === 2 ? '/images/ic_third_place.png' : undefined;
                        if (marker && icon) {
                            const badge: Badge = {
                                name: `(${numberToPlaceValue(index + 1)} Place - ${topicData.categories.find(c => c._id?.$oid === category.category_id)?.name ?? ''})`,
                                icon,
                                // filter text is important for the filter to work. change with caution
                                filterText: `Election Place: ${index + 1}`,
                            };
                            addBadgeToMarker(marker, badge);
                            const title = getMarkerTitle(marker.inner) ?? '';
                            updateMarkerTitle(marker, `${title} - ${badge.name}`);
                        }
                    }
                }
            }
        }

        // if isUserPreview was previously false and is now true, then open creator info drawer. W/o this it will auto open always upon load.
        if (changedProperties.has('isUserPreview')) {
            const oldValue = changedProperties.get('isUserPreview');
            const newValue = this.isUserPreview;
            if (oldValue === false && newValue) {
                await this.setMapDrawer(MapDrawer.MapInfo);
            }
            await this.toggleHiddenPointPreview();
        }

        // reload if we're changing to mobile preview
        if (changedProperties.has('mobilePreview')) {
            const oldValue = changedProperties.get('mobilePreview');
            const newValue = this.isUserPreview;
            if (oldValue === false && newValue) {
                await this.closeMapDrawer();
                await this.firstUpdated();
            }
        }

        if (this.isInStaticMapMode) {
            this.customizeStyles();
        }
    }

    async initializeMapMarkers() {
        if (!pointCache.hasPoints || !this.mapReady) {
            return;
        }

        if (this.focused_point_id !== undefined || this.focused_challenge_location_id !== undefined) {
            try {
                let point: GetPointResponse | undefined;
                let marker: TopLevelMarkerHolder | undefined;
                if (this.focused_point_id !== undefined) {
                    point = pointCache.getPoint(this.focused_point_id);
                    marker = pointCache.getMarker(this.focused_point_id);
                } else if (this.focused_challenge_location_id !== undefined) {
                    const challenge = challengeData.challenge;
                    const challenge_location = challenge?.locations.find(location => location._id?.$oid === this.focused_challenge_location_id);
                    if (challenge_location) {
                        point = pointCache.allPoints.find(p => p.location.latLng.lat === challenge_location.location?.latLng.lat && p.location.search === challenge_location.location.search) ?? undefined;
                        marker = pointCache.getMarker(point?._id.$oid ?? '');
                        if (point) {
                            this.focused_point_id = point._id.$oid;
                        }
                    }
                }
                if (marker !== undefined && point !== undefined) {
                    await this.openPointCard(point);
                }
            } catch {}
        }
    }

    private addTopicRender() {
        // DO NOT add await here, this will cause the entire page to fail to load if the telemetry server is having issues
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        addTopicRender(MapComponent.amplitude_callsite, topicData.topicId, topicData.topic?.organization_id?.$oid);
    }

    private async toggleHiddenPointPreview() {
        // if there are not any active gates, return
        if (await topicData.activeGateDetails(GateType.Password) === undefined && await topicData.activeGateDetails(GateType.Paywall) === undefined && await topicData.activeGateDetails(GateType.Email) === undefined) {
            return;
        }

        const hiddenPoints = pointCache.allPoints.filter((p) => p.is_gate_hidden);

        if (this.isUserPreview) {
            hiddenPoints.forEach((p) => {
                const markerHolder = pointCache.getMarker(p._id.$oid);
                if (markerHolder) {
                    revertIconForMarker(markerHolder);
                    setHiddenIconForMarker(markerHolder);
                }
            });
        } else {
            hiddenPoints.forEach((p) => {
                const markerHolder = pointCache.getMarker(p._id.$oid);
                if (markerHolder) {
                    revertIconForMarker(markerHolder);
                }
            });
        }
    }

    private teamAccessClose() {
        this.teamAccessComponent.close();
        this.isCreating = false;
    }

    async manageAccessClick() {
        logWithAmplitude(MapComponent.amplitude_callsite, 'Manage Access Click');
        this.teamAccessComponent.open = true;
    }

    private challengePopUp() {

        // set a timer for 2 seconds after called.
        // After that time, check if 1) thee user is not registered for the challlenge 2) that the challenge checkin component is not open  and 3) that the email capture modal is not open
        // if all of those are true, then open the challenge modal
        setTimeout(async () => {

            // if there is no challenge on this map do nothing
            if (topicData.allChallenges.length === 0) {
                return;
            }

            /// if this user has already started the challenge, do nothing
            if (this.hasActivatedChallenge) {
                return;
            }
            // make sure nothing else is showing (really this whole thing should be in command center)
            if (this.mapDrawer === undefined) {
                await this.onClickActivateChallenge();
            }
        }
        , 2000);
    };

    private async electionPopUp() {

        // set a timer for 2 seconds after called.
        // After that time, check if 1) thee user is not registered for the challlenge 2) that the challenge checkin component is not open  and 3) that the email capture modal is not open
        // if all of those are true, then open the challenge modal
        setTimeout(async () => {
            // if there is no challenge on this map do nothing
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-boolean-literal-compare
            if (!topicData.hasElection || !electionVotingIsHappening(topicData.electionHappeningNow)) {
                return;
            }
            const eligible = await isVoterEligible(topicData.electionHappeningNow);
            topicData.ballotEligible = eligible;

            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            if (!eligible) {
                return;
            }

            // make sure nothing else is showing (really this whole thing should be in command center)
            if (this.isAdminPortalMobile || this.mapDrawer) {
                return;
            }
            await this.openElectionModal();
        }
        , 2000);
    };

    async refreshMap() {
        this.showMap = false;
        await topicData.refetchTopic(MapComponent.amplitude_callsite);
        this.createTopicRequest = createTopicRequestFromTopic(topicData.topic);
        await this.firstUpdated();

        if (drawingTool.allShapes.length > 0) {
            drawingTool.removeBackgroundMapShapes();
        }

        await this.setMapOptionsAndShowMap();

        await this.pointCardPaginationEl?.firstUpdated();

        if (this.mapDrawer !== MapDrawer.AddPoint && this.mapDrawer !== MapDrawer.EditPoint) {
            await this.closeMapDrawer();
        }

        let focused_point: GetPointResponse | undefined;
        if (this.focused_point_id !== undefined) {
            focused_point = pointCache.getPoint(this.focused_point_id);
        };
        if (focused_point !== undefined) {
            this.lat = focused_point.location.latLng.lat;
            this.lng = focused_point.location.latLng.lng;
            const marker = pointCache.getMarker(focused_point._id.$oid);
            if (marker) {
                await this.focusMarker(marker, focused_point, true);
            }
        } else {
            // case where we are just refreshing and recentering the map after onboarding
            this.lat = this.googleMapComponent.map.getCenter().lat();
            this.lng = this.googleMapComponent.map.getCenter().lng();
        }
    }

    private async setMapOptionsAndShowMap() {
        const additionalMapOptions: google.maps.MapOptions = {};

        // Ensure tilt is disabled.
        const hasImageOverlays = topicData.topic?.custom_overlays !== undefined && topicData.topic.custom_overlays.length > 0;
        additionalMapOptions.tilt = hasImageOverlays ? 0 : topicData.topic?.default_map_tilt ?? 0;
        additionalMapOptions.heading = topicData.topic?.default_map_rotation ?? 0;

        // disable rotation if there are overlays
        if (topicData.topic?.custom_overlays !== undefined && topicData.topic.custom_overlays.length > 0) {
            additionalMapOptions.rotateControl = false;
        }

        // Disable double-click zooming for people who can add points.
        if (topicData.topic?.is_addpointer === true) {
            additionalMapOptions.disableDoubleClickZoom = true;
        }

        // if ware in an iframe, disable the scroll wheel for zooming
        if (inIframe() && !this.isFullScreen && topicData.topic?.embed_gesture_greedy === false) {
            additionalMapOptions.scrollwheel = false;
            additionalMapOptions.gestureHandling = 'auto';
        } else if (inIframe() && !this.isFullScreen && topicData.topic?.embed_gesture_greedy === true) {
            additionalMapOptions.scrollwheel = true;
            additionalMapOptions.gestureHandling = 'greedy';
        }

        // Disable clickable location labels to prevent unwanted pop up windows.
        additionalMapOptions.clickableIcons = false;

        additionalMapOptions.keyboardShortcuts = false;

        additionalMapOptions.mapId = 'd8ce8f89e8ceebd2';

        // Look for satellite or custom styles, or fallback on the defaults.
        if (topicData.topic?.custom_map_style_name === 'satellite') {
            additionalMapOptions.mapTypeId = 'satellite';
        }
        if (topicData.topic?.custom_map_style_name === 'hybrid') {
            additionalMapOptions.mapTypeId = 'hybrid';
        }
        else if (topicData.topic?.custom_map_style_name === 'custom' && topicData.topic?.custom_map_style !== undefined) {
            try {
            additionalMapOptions.styles = JSON.parse(topicData.topic.custom_map_style);
            additionalMapOptions.mapId = undefined;
            } catch (error) {
                console.error('Error parsing custom map style:', error);
                additionalMapOptions.mapId = 'd8ce8f89e8ceebd2';
            }
        } else {
            if (topicData.topic?.custom_map_style_name !== undefined) {
                MAP_STYLES_COLLECTION.forEach((style) => {
                    if (style.title === topicData.topic?.custom_map_style_name) {
                        additionalMapOptions.mapId = style.mapId ?? 'd8ce8f89e8ceebd2';
                    }
                }
                );
            }
        }

        // Set options and allow the map to be shown.
        this.additionalMapOptions = JSON.stringify(additionalMapOptions);
        this.lat = topicData.topic?.default_map_center.latLng.lat ?? 0;
        this.lng = topicData.topic?.default_map_center.latLng.lng ?? 0;
        this.zoom = topicData.topic?.default_map_zoom ?? 4;
        this.showMap = true;
        const creator_profiles = topicData.topic?.creator_profiles ?? [];
        this.creator_profile_id = creator_profiles.length > 0 ? creator_profiles[0].$oid : undefined;

    }

    private async onClickOutParams() {
        if (this.isAdminPortalDesktop || this.isAdminPortalMobile) {
            show_confetti([topicData.backgroundColor, topicData.accentColor]);
            if(getFromLocalStorage('confetti_cannon_toast') !== 'true') {
                setLocalStorage('confetti_cannon_toast', 'true');
                getMainPage().errorToastElement.showToast('You found the secret confetti cannon! 🎉 This only shows for map editors :)');
            }
            return;
        }
        const link = document.createElement('a');
        let href = `https://www.proxi.co/?utm_source=embed&utm_medium=referral&utm_content=powered_by&utm_term=${topicData.topicId}`;

        // Add the map owner's referral code if one exists
        const refCode = topicData.organizationPassiveReferralCode;
        if (refCode) {
            href += `&ref=${encodeURIComponent(refCode)}`;
        }
        await storeReferralFromUrl(href);

        link.href = href;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.click();
    }

    private async loadMapOverlays(custom_overlays: CustomOverlay[]) {
        if (custom_overlays.length === 0) {
            return;
        }
        class CustomOverlayView extends google.maps.OverlayView {
            public div_: HTMLDivElement | null = null;
        }
        const map = this.googleMapComponent.map;

        custom_overlays.forEach(async (overlay, index) => {
            const overlayImage = new CustomOverlayView();

            const imageBounds = await getBoundsForOverlay(overlay);

            if (overlayImage === undefined || overlayImage === null) {
                return;
            }

            // Add the container when the overlay is added to the map.
            overlayImage.onAdd = async function () {
                const div = await createOverlayDiv(overlay, false);
                const panes = this.getPanes();
                if (panes !== undefined && panes !== null) {
                    panes.overlayLayer.appendChild(div);
                }
                this.div_ = div;
            };

            overlayImage.draw = function () {
                if (this.div_ === null) {
                    return;
                }
                // We use these to decide where to place the overlay
                // based on the lat and lng values
                const overlayProjection = this.getProjection();
                const map_rotation = map.getHeading() ?? 0;

                // Place the overlay on the map
                const sw = overlayProjection.fromLatLngToDivPixel(
                    new google.maps.LatLng(imageBounds.south, imageBounds.west)
                );
                const ne = overlayProjection.fromLatLngToDivPixel(
                    new google.maps.LatLng(imageBounds.north, imageBounds.east)
                );

                const panes = this.getPanes();
                if (panes === undefined || panes === null || ne === null || sw === null) {
                    return;
                }

                // Calculate the center point
                const centerX = (sw.x + ne.x) / 2;
                const centerY = (sw.y + ne.y) / 2;

                // Calculate the width and height before rotation
                const width = ne.x - sw.x;
                const height = sw.y - ne.y;

                // Calculate the rotated corners
                const angle = (overlay.position.rotation - map_rotation) * (Math.PI / 180);
                const cosAngle = Math.cos(angle);
                const sinAngle = Math.sin(angle);

                const halfWidth = width / 2;
                const halfHeight = height / 2;

                const rotatedWidth = Math.abs(halfWidth * cosAngle - halfHeight * sinAngle) * 2;
                const rotatedHeight = Math.abs(halfWidth * sinAngle + halfHeight * cosAngle) * 2;

                // Adjust the div location based on the lat and lng values and the map rotation
                const div = this.div_ as HTMLElement;
                div.style.left = `${centerX - rotatedWidth / 2}px`;
                div.style.top = `${centerY - rotatedHeight / 2}px`;
                div.style.width = `${rotatedWidth}px`;
                div.style.height = `${rotatedHeight}px`;

                div.style.pointerEvents = 'auto';

                // Apply CSS transition for smooth rotation
                div.style.transition = 'transform 0.5s ease';

                // Rotate the image
                const rotation_value = overlay.position.rotation - map_rotation;
                div.style.transformOrigin = 'center center';
                div.style.transform = `rotate(${rotation_value}deg)`;
            };

            overlayImage.onRemove = function(){
                this.div_?.parentNode?.removeChild(this.div_);
            };

            // Bind our overlay to the map…
            this.drawnOverlays.push({
                google_overlay: overlayImage,
                position: overlay.position,
                image_url: overlay.image_url,
                _id: overlay._id ?? undefined,
                opacity: overlay.opacity,
            });
        });

        // create waiter until this.drawnOverlay is populated
        // TODO: THIS IS BAD. There has to be a better way to do this but I can't figure it out
        while (this.drawnOverlays.length < custom_overlays.length) {
            await delay(500);
        }

        // Add the overlays to the map
        for (let i = 0; i < this.drawnOverlays.length; i++) {
            const overlay = this.drawnOverlays[i];
            await overlay.google_overlay?.setMap(this.googleMapComponent.map);

            // Wait until overlay.google_overlay.div_ is populated
            while (overlay.google_overlay?.div_ === null) {
                // create waiter until this.drawnOverlay is populated
                // TODO: THIS IS BAD. There has to be a better way to do this but I can't figure it out
                await delay(50);
            }

            if (isDefined(overlay.google_overlay.div_)) {
                overlay.google_overlay.div_.style.display = 'flex';
                // Ensure z-index is set correctly after div is created
                overlay.google_overlay.div_.style.zIndex = (1000 + i).toString();
            }

            overlay.google_overlay?.draw();
        }
    }

    async refreshOverlays() {
        // remove all overlays
        for (const overlay of this.drawnOverlays) {
            if (overlay.google_overlay === null) {
                continue;
            }
            const google_overlay = overlay.google_overlay as google.maps.OverlayView;
            google_overlay.setMap(null);
        }

        // clear the array
        this.drawnOverlays = [];

        // reload the overlays
        await this.loadMapOverlays(topicData.topic?.custom_overlays ?? []);
    }


    private async loadMapGeoJson() {
        // Ensure that there is custom GeoJSON, and that the map has loaded.

        if (topicData.topic?.custom_map_geojson === undefined || topicData.topic?.custom_map_geojson === '') {
            return;
        }

        // Try to parse the GeoJSON to ensure it is valid JSON.
        await getMainPage().errorToastElement.tryOrErrorToast(() => {
            const geojson = (isValidString(topicData.topic?.custom_map_geojson) ? topicData.topic?.custom_map_geojson : '{}') ?? '{}';
            JSON.parse(geojson);
        }, 'An error has occurred.  Context: the custom map GeoJSON could not be parsed (the administrator may need to update it).');

        // Clear any existing loaded GeoJSON.
        this.googleMapComponent.map.data.forEach((f: any) =>
            this.googleMapComponent.map.data.remove(f)
        );

        // Convert to base64 data URL, and load into map.
        const b64geojson = `data:application/json;base64,${btoa(
            topicData.topic.custom_map_geojson
        )}`;
        this.googleMapComponent.map.data.loadGeoJson(b64geojson);
    }

    async loadShapesGeoJson() {
        // get the objects in the topic_custom shapes array
        const customShapes = topicData.topic?.custom_shapes ?? [];

        // if there is no custom_shapes on the topic or og nothing in the custom shapes array, then we dont need to do anything
        if (customShapes.length === 0 || topicData.topic?.custom_shapes === undefined) {
            return;
        }
        drawingTool.instantiateBackgroundMapShapes(this.googleMapComponent.map, customShapes, topicData.isWriter ? this.openBackgroundShapeEdit.bind(this) : undefined);
    }

    private async onMapReady() {
        while (!pointCache.isReady || this.googleMapComponent?.map?.getBounds() === undefined) {
            await delay(0);
        }

        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        await pointCache.instantiateMarkers(
            this.googleMapComponent.map,
            this.onClickMarker.bind(this),
            this.onMarkerDragend.bind(this),
        );

        // Prepare map data.
        this.mapReady = true;
        this.dispatchEvent(
            new CustomEvent('on-map-ready', {
                detail: {
                    map: this.googleMapComponent,
                },
            })
        );

        await Promise.all([this.loadMapGeoJson(), this.loadShapesGeoJson(), this.loadMapOverlays(topicData.topic?.custom_overlays ?? [])]);

        // if the topic has gates that are active and no topic key is set, show the creator info drawer
        if (topicData.topic?.is_gate_limited === true && !this.standaloneMapMode) {
            await this.setMapDrawer(MapDrawer.MapInfo);
        }

        await this.initializeMapMarkers();

        if (topicData.topic?.show_point_list_on_open === true && !this.hidePointCardPaginationOnLoad) {
            this.openListOfPoints();
            if (this.focus_load_parameters?.focusPointId !== undefined) {
                await this.directlySetFocusedPoint(this.focus_load_parameters.focusPointId);
            }
        }

        // Refresh markers when the bounds change.
        google.maps.event.addListener(
            this.googleMapComponent.map,
            'bounds_changed',
            debounce(() => {
                const handler = async () => {
                    if (this.isUserPreview) {
                        try {
                            await this.toggleHiddenPointPreview();
                        } catch (e) {
                            console.error('Error toggling hidden point preview', e);
                        }
                    }
                };
                handler().catch((e) => {
                    return 'Error in refreshing map markers';
                });
            }, 400)
        );

        // if map has image overlays, listen for changes in tilt and reset tilt to 0
        const hasImageOverlays = topicData.topic?.custom_overlays !== undefined && topicData.topic.custom_overlays.length > 0;
        if (hasImageOverlays) {
            google.maps.event.addListener(
                this.googleMapComponent.map,
                'tilt_changed',
                () => {
                    if (this.googleMapComponent.map.getTilt() !== 0) {
                        this.googleMapComponent.map.setTilt(0);
                    }
                }
            );
        }

        // once you have a map visible on the page, you instantiate the bounds with the topicData state
        topicData.instantiateBounds(this.googleMapComponent.map);

        // Hack to remove fullscreen button. leave at end of function b/c it takes time
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        this.googleMapComponent.shadowRoot.querySelector('style').innerHTML +=
            '.gm-fullscreen-control { display: none; }';

        google.maps.event.trigger(this.googleMapComponent.map, 'resize');

    }

    private async clickFullscreen() {
        if (this.isFullScreen) {
            await this.closeFullScreen();
        } else {
            await this.openFullScreen();
        }
    }

    private async openFullScreen() {
        // open page in fullscreen
        const elem = document.documentElement;
        if (isDefined(elem)) {
            try {
                await elem.requestFullscreen();
                this.isFullScreen = true;
                // add listener to listen for full screen closed
                document.addEventListener('fullscreenchange', () => {
                    if (!document.fullscreenElement) {
                        this.isFullScreen = false;
                        // remove listener
                        document.removeEventListener('fullscreenchange', () => {});
                    }
                });
            } catch (error) {
                // If requestFullscreen fails, open the link in a new tab
                if (isDefined(topicData.publicShareLink)) {
                    window.open(topicData.publicShareLink, '_blank');
                } else {
                    getMainPage().errorToastElement.showToast('Error opening fullscreen');
                }
            }
        }
    }

    private async closeFullScreen() {
        // close fullscreen
        if (document.fullscreenElement) {
            try {
                await document.exitFullscreen();
                this.isFullScreen = false;
            } catch (error) {
                getMainPage().errorToastElement.showToast('Error closing fullscreen');
            }
        }
    }

    private async updateCenterToGeolocation() {
        this.startGeolocationLoop(true);
        if (this.geolat === undefined || this.geolng === undefined) {
            return;
        }
        this.lat = this.geolat ?? this.lat;
        this.lng = this.geolng ?? this.lng;
        this.zoom = this.zoom + 2;
        this.addOrUpdateLocationIcon();
        this.geoToggleImage = '/images/geoOn.png';
        logWithAmplitude(MapComponent.amplitude_callsite, 'Geo Button On', {
            topic_id: topicData.topicId,
            topic_key: topicData.topicKey,
            user_starting_lat: this.geolat,
            user_starting_long: this.geolng,
        });

        // await location info from device if needed
        for (let i = 0; i < 3; i++) {
            if (this.geolat === undefined || this.geolng === undefined) {
                await delay(1000);

                // If it's the last iteration and geolat or geolng is still undefined, show the error
                if (i === 2) {
                    getMainPage().errorToastElement?.showToastAndThrow(
                        `Could not get your location. ${inIframe() ? 'The host website may be restricting access.' : 'Please enable location access in your browser settings.'}`
                    );
                }
            } else {
                // If geolat and geolng are defined, break the loop
                break;
            }
        }
    }

    async createPointFromShape() {
        this.drawingIsActive = false;
        this.showDrawToolOptions = false;
        this.askForShapeType = false;

        if (this.foucsedShapeHolder === undefined) {
            console.error('User drawn shape geometry is undefined');
            return;
        }
        await this.setMapDrawer(MapDrawer.AddPoint);
    }


    private async userPointCreateRequestFromLatLng(e: CustomEvent) {
        // dont update when drawers are open already
        if (topicData.topic?.is_addpointer === false || this.mapDrawer === MapDrawer.EditPoint || this.mapDrawer === MapDrawer.AddPoint) {
            return;
        }

        const latLng = e.detail.latLng.toJSON() as LatLng;
        this.userSelectedLatLng = {
            place_id: 'custom',
            latLng,
            search: `${latLng.lat}, ${latLng.lng}`,
        };

        await this.setMapDrawer(MapDrawer.AddPoint);

        logWithAmplitude(
            MapComponent.amplitude_callsite,
            'Open Add Point Modal: Lat Long Click Admin',
            { topic_id: topicData.topicId, topic_key: topicData.topicKey }
        );

        e.preventDefault();
        e.stopPropagation();
        return false;
    }

    async userPointCreateRequestFromLocation(e: CustomEvent) {
        // dont update when drawers are open already
        if (topicData.topic?.is_addpointer === false || this.mapDrawer === MapDrawer.EditPoint || this.mapDrawer === MapDrawer.AddPoint) {
            return;
        }

        this.userSelectedLatLng = e.detail.location as Location;

        await this.setMapDrawer(MapDrawer.AddPoint);

        logWithAmplitude(
            MapComponent.amplitude_callsite,
            'Open Add Point Modal: Location Click Admin',
            { topic_id: topicData.topicId, topic_key: topicData.topicKey }
        );

        e.preventDefault();
        e.stopPropagation();
        return false;
    }

    private startGeolocationLoop(recenter: boolean = false) {
        // There is some type of weird interaction between getPosition and watchPosition, so this doesn't work.
        if (!this.geolocationLoopStarted) {
            this.geolocationLoopStarted = true;
            if (recenter) {
                this.asyncRecenter = true;
            }
            // Chrome (and friends) only expose geolocation on secure origins.
            // Surface this up front rather than letting watchPosition return a
            // PERMISSION_DENIED with no UI hint about *why*.
            if (typeof window !== 'undefined' && !window.isSecureContext) {
                this.asyncRecenter = false;
                this.geolocationLoopStarted = false;
                getMainPage().errorToastElement?.showToast(
                    'Sharing your location requires a secure (https://) connection.'
                );
                return;
            }
            if (typeof navigator === 'undefined' || !('geolocation' in navigator)) {
                this.asyncRecenter = false;
                this.geolocationLoopStarted = false;
                getMainPage().errorToastElement?.showToast(
                    "This browser doesn't support sharing your location."
                );
                return;
            }
            navigator.geolocation.watchPosition(
                (geo) => {
                    const lat = geo.coords.latitude;
                    const lng = geo.coords.longitude;

                    this.geolat = lat;
                    this.geolng = lng;
                    pointCache.userLocation = { lat, lng };
                },
                (err) => {
                    this.asyncRecenter = false;
                    this.geolocationLoopStarted = false;
                    const inFrame = inIframe();
                    let message: string;
                    switch (err.code) {
                        case 1:
                            message = inFrame
                                ? 'Location access is blocked. The host site may be restricting it, or you can allow location for this site in your browser.'
                                : 'Location access is blocked. Open the site permissions in the address bar to allow it, then try again.';
                            break;
                        case 2:
                            message = "We couldn't determine your location. On a Mac, check System Settings → Privacy & Security → Location Services. On phones, make sure Location is on.";
                            break;
                        case 3:
                            message = 'Location request timed out. Check your signal and try again.';
                            break;
                        default:
                            message = "We couldn't get your location. Try again or check your browser's location permissions.";
                    }
                    getMainPage().errorToastElement?.showToast(message);
                },
            );
        }
    }

    addOrUpdateLocationIcon() {
        if (this.geolocationMarker !== undefined && this.geolat !== undefined && this.geolng !== undefined) {
            updateMarkerVisibility(this.geolocationMarker, true);
            updateMarkerPosition(this.geolocationMarker, new google.maps.LatLng(this.geolat, this.geolng));
            setMarkerMap(this.geolocationMarker, this.googleMapComponent.map);
        } else if (this.geolocationMarker === undefined && this.geolat !== undefined && this.geolng !== undefined) {
            const icon = {
                url: '/images/geo.svg',
                scaledSize: new google.maps.Size(30, 30),
                anchor: new google.maps.Point(15, 15),
            };
            const position = new google.maps.LatLng(this.geolat, this.geolng);
            const marker = getMarkerElement(this.googleMapComponent.map, position, icon, 200, pointCache.advancedMarkers);
            this.geolocationMarker = marker;
            setMarkerMap(this.geolocationMarker, this.googleMapComponent.map);
        }
    }

    private onListOfPointsClosed() {
        if (!this.multiSelectionEnabled) {
            revertIconForMarker(this.focusedMarker);
        }

        const newRemovedUrl = removeParameterFromURL(window.location.href, 'point_id');
        replaceStateWithPageName(newRemovedUrl);
        this.removeAllFocus();
    }

    private openListOfPoints() {
        this.pointListOpen = true;
        this.pointDrawer?.open();
    }

    closeListOfPoints(removeFocus: boolean = true) {
        this.pointListOpen = false;

        if (this.pointDrawer?.isOpened === true) {
            this.pointDrawer?.close();
            if (detectMobileViewport(this.mobilePreview)) {
                // If it's a mobile device, pan the map vertically
                this.googleMapComponent.map.panBy(
                    0,
                    -1.0 *
                        Math.min(
                            204.0,
                            (0.4 * this.googleMapComponent.offsetHeight) / 2.0
                        ) /* half-height of the peek drawer */
                );
            } else {
                // If it's not a mobile device, pan the map horizontally
                this.googleMapComponent.map.panBy(
                    1.0 *
                        Math.min(
                            204.0,
                            (0.4 * this.googleMapComponent.offsetWidth) / 2.0
                        ) /* half-width of the peek drawer */,
                    0
                );
            }
            if (removeFocus) {
                this.removeAllFocus();
            }
        }
    }

    removeAllFocus() {
        if (this.mapDrawer !== MapDrawer.EditPoint) {
            this.highlightedPoint = undefined;
            this.focusedPoint = undefined;
            this.focused_point_id = undefined;
            this.focusedMarker = undefined;
            this.selectedPoints = [];
        }
    }

    async onClickMarker(markerHolder: TopLevelMarkerHolder) {
        const point = markerHolder.point;

        await this.onClickPoint(point);
    }

    async onClickPoint(point: GetPointResponse) {
        if (this.isPrintView) {
            return;
        }
        if (point.is_gate_hidden && (topicData.topic?.is_gate_limited === true || this.isUserPreview)) {
            if (this.mapDrawer !== MapDrawer.MapInfo) {
                await this.setMapDrawer(MapDrawer.MapInfo);
            }
            getMainPage().errorToastElement?.showToastAndThrow('This point is hidden. Please access the map to view it.');
        }
        this.highlightedPoint = point;
        this.focusedPoint = point;
        await this.openPointCard(point);
        if (this.mapDrawer === MapDrawer.MapInfo && detectMobileViewport(this.mobilePreview)) {
            // On mobile, show the point inline in the MapInfo drawer instead of closing it
            topicData.mobileDrawerFocusedPoint = point;
            return;
        }
        await this.directlySetFocusedPoint(point._id.$oid);
    }

    // should use onClickPointMarker instead of this function elsewhere
    private async openPointCard(
        point: GetPointResponse,
    ) {
        if (this.focusedPoint !== undefined) {
            revertIconForMarker(this.focusedMarker);
        }

        const newRemovedUrl = removeParameterFromURL(window.location.href, 'point_id');
        replaceStateWithPageName(newRemovedUrl);
        this.focused_point_id = undefined;


        // Center on point
        // Console revisit to not change bounds every time
        await this.adjustBoundsAndCenterPoint(point.location.latLng);

        // Change the marker icon to indicate that it is open.
        this.focusedPoint = point;

        if (this.multiSelectionEnabled) {
            this.selectedPoints = [...new Set([...this.selectedPoints, point])];
        } else {
            this.selectedPoints = [point];
        }

        this.highlightedPoint = point;

        const newUrl = addParameterToURL(window.location.href, 'point_id', point._id.$oid);
        replaceStateWithPageName(newUrl);

        this.focused_point_id = point._id.$oid;

        this.openListOfPoints(); // set point list as open
    }


    private onMapClick(e: MouseEvent) {
        if (!this.multiSelectionEnabled) {
            this.closeListOfPoints();
        }
    }

    async focusMarker(
        markerHolder: TopLevelMarkerHolder,
        point: GetPointResponse,
        zoom: boolean = false,
        extend_bounds: boolean = false
    ) {
        if (this.focusedMarker === markerHolder) {
            return;
        }

        if (!this.multiSelectionEnabled) {
            revertIconForMarker(this.focusedMarker);
        }
        this.focusedMarker = markerHolder;

        setFocusIconForMarker(this.focusedMarker);

        if (zoom && !extend_bounds) {
            const newPosition = point.location.latLng;
            await this.adjustBoundsAndCenterPoint(newPosition);
        } else if (zoom && extend_bounds) {
            const newPosition = point.location.latLng;
            await this.adjustBoundsAndCenterPoint(newPosition, true);
        }

    }

    // general function to handle when to recenter and move map bounds
    // we want to minimize this movement as much as possible to reduce jumpiness
    // and flickering
    private async adjustBoundsAndCenterPoint(latLng: LatLng, extend_bounds: boolean = false) {
        const currentBounds = this.googleMapComponent?.map?.getBounds();
        const visibleBounds = await this.getVisibleBounds(currentBounds);
        if (!visibleBounds.contains(latLng)) {
            if (!extend_bounds) {
                const boundsPadding = await this.getMovingBoundsPadding();
                await this.googleMapComponent.map.panTo(latLng);
                this.googleMapComponent.map.panBy(boundsPadding.right - boundsPadding.left, boundsPadding.bottom-boundsPadding.top);
            } else {
                const boundsPadding = await this.getMovingBoundsPadding();
                const newBounds = new google.maps.LatLngBounds(visibleBounds.getSouthWest(), visibleBounds.getNorthEast());
                newBounds.extend(new google.maps.LatLng(latLng.lat, latLng.lng));
                // add some extra padding when extending bounds to top, left, right
                boundsPadding.top += 60;
                boundsPadding.left += 60;
                boundsPadding.right += 60;
                this.googleMapComponent.map.fitBounds(newBounds, boundsPadding);
            }
        }
    }

    // this function is called when a user clicks on a point marker and we need to shift the bounds of the map but
    // dont want the new point to be under the drawer
    private async getMovingBoundsPadding(): Promise<BoundsPadding> {
        return await new Promise((resolve) => {
            const boundsPadding = {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
            };

            if (inSmallScreen()) {
                boundsPadding.bottom = this.googleMapComponent.offsetHeight/3;
            } else if (this.mapDrawer === MapDrawer.MapInfo) {
                boundsPadding.right =
                    (0.4 * this.googleMapComponent.offsetWidth)/2;
            } else if (this.pointListOpen) {
                boundsPadding.left =
                    (0.4 * this.googleMapComponent.offsetWidth)/2;
            }
            resolve(boundsPadding);
        });
    }

    // a funciton to get the visible bounds of the map -- mostly used to check if a point is in the visible bounds
    private async getVisibleBounds(bounds: google.maps.LatLngBounds): Promise<google.maps.LatLngBounds> {
        return await new Promise((resolve) => {
            const ne = bounds.getNorthEast();
            const sw = bounds.getSouthWest();
            const latDiff = ne.lat() - sw.lat();
            const lngDiff = ne.lng() - sw.lng();

            if (inSmallScreen()) {
                // remove 1/3 of visible area from the bottom
                // remove 1/6 of visible area from the top and sides
                const newNe = new google.maps.LatLng(
                    ne.lat() - latDiff / 6,
                    ne.lng() - lngDiff / 6
                );
                const newSw = new google.maps.LatLng(
                    sw.lat() + latDiff * 1 / 3,
                    sw.lng() + lngDiff / 6
                );
                const visibleBounds = new google.maps.LatLngBounds(newSw, newNe);
                resolve(visibleBounds);
            } else if (this.mapDrawer) {
                // remove 40% of visible area from the right
                // remove 1/8 of visible area from the top, bottom, and left
                const newNe = new google.maps.LatLng(
                    ne.lat() - latDiff / 8,
                    ne.lng() - lngDiff * 0.4
                );
                const newSw = new google.maps.LatLng(
                    sw.lat() + latDiff / 8,
                    sw.lng() + lngDiff / 8
                );
                const visibleBounds = new google.maps.LatLngBounds(newSw, newNe);
                resolve(visibleBounds);
            } else if (this.pointListOpen) {
                // remove 55% of visible area from the left (extra b/c point card can take up more than half on discover details)
                // remove 1/8 of visible area from the top, bottom, and right
                const newNe = new google.maps.LatLng(
                    ne.lat() - latDiff / 8,
                    ne.lng() - lngDiff / 8
                );
                const newSw = new google.maps.LatLng(
                    sw.lat() + latDiff / 8,
                    sw.lng() + lngDiff * 0.55
                );
                const visibleBounds = new google.maps.LatLngBounds(newSw, newNe);
                resolve(visibleBounds);
            } else {
                // remove 1/8 of visible area from the top, bottom, left, and right in case it is right on the edge
                const newNe = new google.maps.LatLng(
                    ne.lat() - latDiff / 8,
                    ne.lng() - lngDiff / 8
                );
                const newSw = new google.maps.LatLng(
                    sw.lat() + latDiff / 8,
                    sw.lng() + lngDiff / 8
                );
                const visibleBounds = new google.maps.LatLngBounds(newSw, newNe);
                resolve(visibleBounds);
            }
        });
    }

    rotateMap(value: number = 90) {
        // cannot rotate map if overlays are being edited
        if (this.mapDrawer === MapDrawer.OverlayEditor) {
            getMainPage().errorToastElement.showToast('Cannot rotate map while editing overlays');
            return;
        }
        // set heading to +90 degrees
        const amount = value;
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        this.googleMapComponent.map.setHeading(amount);
    }

    tiltMap(value: number = 45) {
        if (this.mapDrawer === MapDrawer.OverlayEditor) {
            getMainPage().errorToastElement.showToast('Cannot tilt map while editing overlays');
            return;
        }

        if (topicData.topic?.custom_overlays !== undefined && topicData.topic.custom_overlays.length > 0) {
            getMainPage().errorToastElement.showToast('Cannot tilt map with image overlays');
            return;
        }

        const amount = value;
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        this.googleMapComponent.map.setTilt(amount);
    }

    async onPointShare(p: GetPointResponse) {
        this.focusedPoint = p;
        await this.setMapDrawer(MapDrawer.PointShare);

        logWithGoogleTagAndTopicOrganization(MapComponent.amplitude_callsite, GoogleTagEvent.POINT_SHARE_CLICKED, {
            point_id: p._id.$oid,
            point_name: p.name,
        });
    }

    async onPointAdd() {
        this.userSelectedLatLng = undefined;
        this.foucsedShapeHolder = undefined;

        await this.setMapDrawer(MapDrawer.AddPoint);

        logWithAmplitude(MapComponent.amplitude_callsite, 'Open Add Point: Point Click Admin', {
            topic_id: topicData.topicId,
            topic_key: topicData.topicKey,
        });
    }

    async onPointEdit(p: GetPointResponse) {
        this.focusedPoint = p;
        await this.setMapDrawer(MapDrawer.EditPoint);

        logWithAmplitude(MapComponent.amplitude_callsite, 'Open Edit Point: Point Click Admin', {
            topic_id: topicData.topicId,
            topic_key: topicData.topicKey,
        });
        this.closeListOfPoints();
    }

    private async onMarkerDragend(markerHolder: TopLevelMarkerHolder, locationBeforeDrag?: Location) {
        const point = markerHolder.point;

        await this.onPointDragend(point, locationBeforeDrag);
    }

    private async onPointDragend(point: GetPointResponse, locationBeforeDrag?: Location) {
        const markerHolder = pointCache.getMarker(point._id.$oid);
        if (markerHolder === undefined) {
            return;
        }
        const latLng = getMarkerPosition(markerHolder.inner);
        if (locationBeforeDrag !== undefined) {
            this.locationBeforeDrag = locationBeforeDrag;
        }

        if (latLng === undefined || latLng === null) {
            return;
        }

        this.focusedPoint = point;
        this.userSelectedLatLng = {
            place_id: 'custom',
            latLng,
            search: `${latLng.lat}, ${latLng.lng}`,
        };

        await this.setMapDrawer(MapDrawer.EditPoint);

        revertIconForMarker(markerHolder);

        logWithAmplitude(MapComponent.amplitude_callsite, 'Open Edit Point Modal: Drag Admin', {
            topic_id: topicData.topicId,
        });
    }

    async onActivateChallenge(link_set?: ActivatedChallengeLinkSet) {
        this.isLoadingChallenge = true;
        this.challenge = topicData.challengeHappeningNow;
        this.activatedChallenge = challengeData.activated_challenge;

        // Ensure that local storage, amplitude, and chameleon have an email if possible
        // Because we are constantly adding new tools that require login, we should always run this to make sure all are updated
        const local_storage_email = getFromLocalStorage('email');
        if (accountInfo.isAuthenticated) {
            saveEmail(accountInfo.email);
            void show_confetti([topicData.backgroundColor, topicData.textColor]);
        } else if (local_storage_email !== null) {
            saveEmail(local_storage_email);
            void show_confetti([topicData.backgroundColor, topicData.textColor]);
        }

        if (isDefined(topicData.topic)) {
            await pointCache.instantiatePointCache(
                topicData.topic,
                topicData.topicKey,
                true,
                true,
                this.isPrintView ? undefined : challengeData.challenge ? challengeData.allCheckins : accountInfo.account_checkins,
            );
        }

        await challengeData.refreshCheckins();
        this.isLoadingChallenge = false;
    }

    async onToggleElection(pendingVote?: PendingVote) {
        const focused_point_id = this.focusedPoint?._id.$oid;
        if (isDefined(this.election)) {
            this.pendingVote = pendingVote ?? this.pendingVote;
            await this.setMapDrawer(MapDrawer.ElectionBallot);
        }

        // if point cards are open close them
        if (this.pointListOpen) {
            this.closeListOfPoints(false);
        }

        if (isDefined(focused_point_id)) {
            this.electionFormElement?.setFocusedPoint(focused_point_id);
        }
    }

    async onToggleNomination() {
        const focused_point_id = this.focusedPoint?._id.$oid;
        if (isDefined(this.election)) {
            await this.setMapDrawer(MapDrawer.Nomination);
        }
        if (this.pointListOpen) {
            this.closeListOfPoints(false);
        }

        if (isDefined(focused_point_id)) {
            this.nominationComponent?.setFocusedPoint(focused_point_id);
        }
    }

    async onToggleCheckin(point: GetPointResponse, isCheckedIn?: Boolean, hasActiveChallenge?: Boolean, openChallengeModal?: Boolean) {
        const isCheckedin = isCheckedIn ?? false;
        this.pendingCheckinPoint = undefined;

        if (isDefined(point) && isDefined(topicData.topic)) {
            if (accountInfo.isAuthenticated) {
                if (isCheckedin === true) {
                    if (hasActiveChallenge === true) {
                        this.pendingCheckinPoint = point;
                        await this.openChallengeUncheckConfirmModal();
                    } else {
                        await accountInfo.removeCheckin(point.location);
                        await pointCache.updateCheckIns(point);
                        this.requestUpdate();
                    }
                } else {
                    if (hasActiveChallenge === true) {
                        this.pendingCheckinPoint = point;
                        this.challenge = challengeData.challenge;
                        this.activatedChallenge =  challengeData.activated_challenge;
                        this.currentRewards = this.activatedChallenge?.earned_rewards ?? [];
                        await this.openChallengeModal();
                    } else {
                        await accountInfo.createStandardCheckin(topicData.topic._id, point.location);
                        await pointCache.updateCheckIns(point);

                        logWithGoogleTag('Generic Check In', GoogleTagEvent.USER_CHECKED_IN, {
                            topic_id: topicData.topic?._id?.$oid,
                            point_id: point._id.$oid,
                            organization_id: topicData.topic?.organization_id?.$oid,
                            challenge_name: challengeData.challenge?.name ?? '',
                        });
                    }
                }
            } else {
                this.pendingCheckinPoint = point;
                await this.openChallengeModal();
            }
        } else if (openChallengeModal === true) {
            await this.openChallengeModal();
        }
        await challengeData.refreshCheckins();
    }

    async onClickActivateChallenge() {
        if (challengeData.activated_challenge) {
            await this.openChallengeParticipantProgress();
        } else {
            await this.openChallengeModal();
        }
        this.requestUpdate();
        logWithAmplitude(MapComponent.amplitude_callsite, 'Open Challenge: Challenge Click', {
            topic_id: topicData.topicId,
            topic_key: topicData.topicKey,
        });
    }


    async openChallengeModal() {
        this.open_checkin_challenge = true;
        await this.setMapDrawer(MapDrawer.ChallengeCheckIn);
    }

    async openElectionModal() {
        this.open_election = true;
        if (!this.pendingVote && isDefined(this.focusedPoint)) {
            this.pendingVote = {
                topic_category_id: this.focusedPoint.topic_category_id,
                selected_points: [this.focusedPoint._id]
            };
        }
        await this.setMapDrawer(MapDrawer.ElectionBallot);

        if (this.focusedPoint) {
            this.electionFormElement?.setFocusedPoint(this.focusedPoint._id.$oid);
        }
    }

    resetUserSelectedLatLng() {
        this.userSelectedLatLng = undefined;
        this.locationBeforeDrag = undefined;
    }

    async closeChallengeModal() {
        this.showEmailConfirm = false;
        removeLocalStorage('signin_modal');

        this.open_checkin_challenge = false;
        await this.closeMapDrawer();
    }

    private async closeElectionModal() {
        this.showEmailConfirm = false;

        this.open_election= false;
        await this.closeMapDrawer();
    }

    async openChallengeUncheckConfirmModal() {
        await this.setMapDrawer(MapDrawer.ChallengeUncheck);
    }

    async closeChallengeUncheckConfirmModal() {
        this.pendingCheckinPoint = undefined;
        await this.closeMapDrawer();
    }

    private async handleChallengeUncheckConfirm() {
        if (isDefined(this.pendingCheckinPoint)) {
            await accountInfo.removeCheckin(this.pendingCheckinPoint.location);
            await pointCache.updateCheckIns(this.pendingCheckinPoint);

            if (isDefined(topicData.topic)) {
                await pointCache.instantiatePointCache(
                    topicData.topic,
                    topicData.topicKey,
                    true,
                    true,
                    this.isPrintView ? undefined : challengeData.challenge ? challengeData.allCheckins : accountInfo.account_checkins,
                );
            }

            await challengeData.setActivatedChallengeForUser();

        }
        await this.closeChallengeUncheckConfirmModal();
    }

    private async closeRouteComponent() {
        this.optimizedRouteComponent.resetAll();
        await this.closeMapDrawer();
        this.requestUpdate();
    }

    private async updateUserName(e: CustomEvent) {
        const full_name = e.detail?.userName;

        if (accountInfo.fullName !== full_name) {
            await getMainPage().errorToastElement.tryOrErrorToast(async () => {
                const updatedAccount: CreateAccountRequest = {
                    _id: accountInfo.id,
                    full_name,
                    email: accountInfo.email,
                    bookmarks: accountInfo.bookmarks,
                    followed_profiles: accountInfo.followedProfiles,
                    phone_number: accountInfo.phoneNumber,
                    image_url: accountInfo.image,
                    migrated_from_personal: accountInfo.migrated_from_personal ?? false,
                };

                await setAccount(CheckinChallengeComponent.amplitude_callsite, updatedAccount, {
                    update: 'Full Name',
                }, LoginOrigin.Checkin);

                accountInfo.fullName = full_name;
            }, 'An error has occurred.  Context: could not update the account.');
        }
    }

    private async setDefaultOrientationAndCenter() {
        await topicData.refetchTopic(MapComponent.amplitude_callsite);
        // also get the tilt and heading
        const hasImageOverlays = topicData.topic?.custom_overlays !== undefined && topicData.topic.custom_overlays.length > 0;
        const tilt = Math.round(hasImageOverlays ? 0 : this.googleMapComponent.map.getTilt() ?? 0);
        const heading = Math.round(this.googleMapComponent.map.getHeading() ?? 0);
        const updatedTopic: Partial<CreateTopicRequest> = {
            default_map_center: {
                latLng: {
                    lat: this.googleMapComponent.map.getCenter().lat(),
                    lng: this.googleMapComponent.map.getCenter().lng()
                },
                search: '',
                place_id: ''
            },
            default_map_zoom: Math.round(this.googleMapComponent.map.getZoom()), // update once this doesnt have to be an integer
            default_map_tilt: tilt,
            default_map_rotation: heading,
        };

        await topicData.fetchAndUpdateTopicData(updatedTopic, MapComponent.amplitude_callsite);

        this.showSetDefaultZoomCenter = false;
    }

    private latLongZoomChanged() {
        if (!(this.lat === 0)) { // hack to make it not show up when the map is loading
            if (this.lat !== topicData.topic?.default_map_center.latLng.lat || this.lng !== topicData.topic?.default_map_center.latLng.lng || Math.round(this.zoom) !== topicData.topic?.default_map_zoom) {
                if (this.isAdminPortalMobile || this.isAdminPortalDesktop) {
                    this.showSetDefaultZoomCenter = true;
                }
            }
        }
    }

    private async dismissEmailCaptureModal() {
        await this.emailCapturePopUpElement?.dismiss();
    }

    private async closeEmailCaptureModal(e: CustomEvent) {
        const onlyShowOnce = e.detail.onlyShowOnce;
        const modal_id = e.detail.modal_id;
        if (onlyShowOnce === true) {
            setLocalStorage('hidePopUp', modal_id);
        }
        if (detectMobileViewport(this.mobilePreview)) {
            await this.closeMapDrawer();
        } else {
            await this.closeMapPopUp();
            await this.closeMapDrawer();
        }
    }

    async openAwardAnnouncementModal() {
        await this.setMapDrawer(MapDrawer.ChallengeAwardAnnouncement);
        void show_confetti([topicData.backgroundColor, topicData.textColor]);
    }

    async startDrawing(type: google.maps.drawing.OverlayType, straightToData: boolean = false) {
        this.isEnabledDrawShape = true;
        this.drawingIsActive = true;
        this.showDrawToolOptions = true;
        await this.closeMapDrawer();

        drawingTool.startDrawing(this.googleMapComponent.map, type, async (geometry: GeoJsonGeometry, circleDetails? : CircleDetails) => await this.handleDrawingComplete(geometry, straightToData, circleDetails));
    }

    async handleDrawingComplete(f: GeoJsonGeometry, straightToData: boolean = false, circleDetails?: CircleDetails) {
        this.askForShapeType = true;
        this.drawingIsActive = false;
        this.isEnabledDrawShape = false;
        const geometry = {
            type: f.type,
            coordinates: f.coordinates,
        };

        const shape: CustomShape = {
            name: `Custom Shape ${(topicData.topic?.custom_shapes?.length ?? 0) + 1}`,
            description: undefined,
            geojson: geometry,
            style: topicData.topic?.default_shape_style ?? {
                stroke_color: topicData.backgroundColor ?? undefined,
                stroke_weight: 1,
                stroke_opacity: 1,
                fill_color: topicData.backgroundColor ?? undefined,
                fill_opacity: 0.5,
            }
        };

        if (circleDetails && isDefined(circleDetails.center) && isDefined(circleDetails?.radius_m)) {
            shape.circle_details = {
                center: circleDetails.center,
                radius_m: circleDetails.radius_m,
            };
        } ;



        this.foucsedShapeHolder = createShapeHolderFromCustomShape(shape);
        addShapeToMap(this.foucsedShapeHolder.inner, this.googleMapComponent.map);
        setShapeOptions(this.foucsedShapeHolder.inner, {clickable: false});

        if (straightToData) {
            this.askForShapeType = false;
            await this.createPointFromShape();
        } else {
            await this.setMapDrawer(MapDrawer.EditShape);
            if (isDefined(this.shapeModalContent)) {
                this.shapeModalContent.showSelectShapeType = true;
            }
        }

        drawingTool.reset();
    }

    private async closeCreatorInfoDrawer() {
        topicData.mobileDrawerFocusedPoint = undefined;
        await this.closeMapDrawer();
        this.requestUpdate();
    }

    disableDrawMode() {
        this.googleMapComponent.map.setOptions({ draggableCursor: 'default' });
        this.googleMapComponent.map.data.setDrawingMode(null);
        this.drawingMode = undefined;
        this.isEnabledDrawShape = false;
        this.drawingIsActive = false;
        this.askForShapeType = false;
        drawingTool.reset();
    }

    async toggleShowDrawToolOptions() {
        this.showDrawToolOptions = !this.showDrawToolOptions;

        // temp
        await this.setMapDrawer(MapDrawer.EditShape);
        if (isDefined(this.shapeModalContent)) {
            this.shapeModalContent.focusedShape = undefined;
        }

        if (this.showDrawToolOptions) {
            // do nothing
        } else {
            this.disableDrawMode();
        }
    }

    private async toggleShowOverlayImageUpload() {
        await this.setMapDrawer(MapDrawer.OverlayEditor);

        if (this.showOverlayImageUpload) {
            // do nothing
        } else {
            this.disableImageUpload();
        }
    }

    private disableImageUpload() {
        this.showOverlayImageUpload = false;
    }

    async setFocusedPoint(e: CustomEvent) {
        if (e.detail.focused === true) {
            const marker = pointCache.getMarker(e.detail.point._id.$oid);
            if (marker) {
                await this.focusMarker(marker, e.detail.point, true);
            }
        } else {
            revertIconForMarker(this.focusedMarker);
            this.focusedMarker = undefined;
        }
    }

    async directlySetFocusedPoint(id: string, extend_bounds: boolean = false) {
        const point = pointCache.getPoint(id);
        if (point) {
            const marker = pointCache.getMarker(point._id.$oid);
            if (marker) {
                await this.focusMarker(marker, point, true, extend_bounds);
            }
        }
    }

    /// Nearby Places Calls

    private onNearbyPlacesFound(e: CustomEvent) {
        const newResults = e.detail.results;
        this.nearbySearchResults = newResults;


        // make map not draggable or zoomable
        this.googleMapComponent.map.setOptions({
            draggable: false,
            zoomControl: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
        });

        // make the circle not draggable or editable
        this.nearbyPointsSearchCircle?.setOptions({
            fillColor: palette.primaryBlue,
            strokeWeight: 2,
            strokeOpacity: 1,
            draggable: false,
            editable: false,
        });

        // plot the nearby places on the map
        this.nearbySearchResults?.forEach((place, index) => {
            setTimeout(() => {
                const icon  = {
                    url: 'https://img.icons8.com/?size=48&id=19326&format=png',
                    scaledSize: new google.maps.Size(30, 30),
                    anchor: new google.maps.Point(15, 15),
                };
                const marker = getMarkerElement(this.googleMapComponent.map, place.location.latLng, icon, 500, pointCache.advancedMarkers, undefined, place.location.place_id);

                setMarkerMap(marker, this.googleMapComponent.map);
                // add click listener to marker
                marker.addListener('click', async () => {
                    await this.setNearbyPlaceFocus(new CustomEvent('set-nearby-place-focus', { detail: { result: place } }));

                });

                // add mouseover listener to marker
                marker.addListener('mouseover', async () => {
                    await this.setNearbyPlaceFocus(new CustomEvent('set-nearby-place-focus', { detail: { result: place } }));
                });

                // add to map
                this.nearbySearchMarkers.push(marker);
            }, index * 200); // 200ms delay between each marker
        });
    }

    private onNearbyPlacesUpdated(e: CustomEvent) {
        // compare to existing results, add or remove markers as needed
        const addedResults: CreatePointRequest[] = e.detail.added;
        const removedResults: CreatePointRequest[] = e.detail.removed;

        if (this.nearbySearchResults) {
            this.nearbySearchResults = this.nearbySearchResults.concat(addedResults);
            this.nearbySearchResults = this.nearbySearchResults.filter(
                (result) => !removedResults.includes(result)
            );
        }

        // remove markers
        removedResults.forEach((result) => {
            // match on title
            const marker = this.nearbySearchMarkers.find(
                (marker) => getMarkerTitle(marker) === result.location.place_id
            );

            if (marker !== undefined) {
                updateMarkerVisibility(marker, false);
                this.nearbySearchMarkers.splice(this.nearbySearchMarkers.indexOf(marker), 1);
            }
        });

        // add markers to map.
        addedResults.forEach((result) => {
            const icon  = {
                url: 'https://img.icons8.com/?size=48&id=8ggStxqyboK5&format=png',
                scaledSize: new google.maps.Size(30, 30),
                anchor: new google.maps.Point(15, 15),
            };
            const marker = getMarkerElement(this.googleMapComponent.map, result.location.latLng, icon, 500, pointCache.advancedMarkers, undefined, result.location.place_id);

            // add click listener to marker
            marker.addListener('click', async () => {
                await this.setNearbyPlaceFocus(new CustomEvent('set-nearby-place-focus', { detail: { result } }));
            });

            // add mouseover listener to marker
            marker.addListener('mouseover', async () => {
                await this.setNearbyPlaceFocus(new CustomEvent('set-nearby-place-focus', { detail: { result } }));
            });

            // add to map
            this.nearbySearchMarkers.push(marker);
        });
    }

    private async resetNearbySearchResults(closeDrawer: boolean = true) {
        this.nearbySearchResults = [];
        this.nearbySearchMarkers.forEach((marker) => {
            updateMarkerVisibility(marker, false);
        });
        this.nearbySearchMarkers = [];

        if (closeDrawer) {
            this.googleMapComponent.map.panBy(
                1.0 *
                    Math.min(
                        204.0,
                        (0.3 * this.googleMapComponent.offsetWidth) / 2.0
                    ) /* half-width of the peek drawer */,
                0
            );
            this.nearbyPointsSearchCircle?.setMap(null);
            this.nearbyPointsSearchCircle = undefined;
            // make markers bigger again
            pointCache.markersInBounds.forEach((markerHolder) => {
                const icon: google.maps.Icon = {
                    url: markerHolder.iconUrl ?? '',
                    scaledSize: new google.maps.Size(30, 30),
                    anchor: new google.maps.Point(15, 15),
                };
                if (!markerHolder.customShape) {
                    updateMarkerIcon(markerHolder.inner, icon);
                }
                setMarkerClickable(markerHolder.inner, true);
            });

            // reset the search center to the map center
            this.nearbySearchCenter = {
                lat: this.googleMapComponent.map.getCenter().lat(),
                lng: this.googleMapComponent.map.getCenter().lng()
            };

            this.showNearbyPlacesSearchModal = false;
        } else {
            this.nearbyPointsSearchCircle?.setOptions({
                fillColor: palette.primaryBlue,
                strokeWeight: 2,
                strokeOpacity: 1,
                draggable: true,
                editable: true,
            });
        }

        // make map draggable and zoomable again
        this.googleMapComponent.map.setOptions({
            draggable: true,
            scrollwheel: true,
            disableDoubleClickZoom: topicData.topic?.is_addpointer,
        });

        await pointCache.refreshPoints();
    }

    private async setNearbyPlaceFocus(e: CustomEvent) {
        this.focusedNearbySearchResult = e.detail.result;
        const point = e.detail.result;

        // look for point in nearby search markers
        const marker = this.nearbySearchMarkers.find(
            (marker) => getMarkerTitle(marker) === point.location.place_id
        );

        if (marker !== undefined) {
            const icon: google.maps.Icon = {
                url: 'https://img.icons8.com/?size=48&id=8ggStxqyboK5&format=png',
                scaledSize: new google.maps.Size(30, 30),
                anchor: new google.maps.Point(15, 15),
            };
            updateMarkerIcon(marker, icon);
            updateMarkerZIndex(marker, 1000);
        }

        // remove focus from all other markers
        this.nearbySearchMarkers.forEach((m) => {
            if (m !== marker) {
                const icon: google.maps.Icon = {
                    url: 'https://img.icons8.com/?size=48&id=19326&format=png',
                    scaledSize: new google.maps.Size(30, 30),
                    anchor: new google.maps.Point(15, 15),
                };
                updateMarkerIcon(m, icon);
                updateMarkerZIndex(m, 500);
            }
        });
    }

    private async closeNearbyPlacesSearchModal() {
        await this.resetNearbySearchResults();
        this.showNearbyPlacesSearchModal = false;
    }

    private openNearbyPointsSearchDrawer() {
        this.showNearbyPlacesSearchModal = true;
        // pan the map horizontally to the right
        this.googleMapComponent.map.panBy(
            -1* Math.min(
                204.0,
                (0.3 * this.googleMapComponent.offsetWidth) / 2.0
            ) /* half-width of the peek drawer */,
            0
        );

        // scale the radius based on the zoom level
        const zoom = this.googleMapComponent.map.getZoom();
        const scale = 1.0 / (Math.pow(2, zoom));
        this.nearbySearchRadius = 10000000 * scale;

        // add a draggable circle to the map center to show the search radius
        this.nearbyPointsSearchCircle = new google.maps.Circle({
            strokeColor: palette.primaryBlue,
            strokeOpacity: 1,
            strokeWeight: 2,
            fillColor: palette.primaryBlue,
            fillOpacity: 0.5,
            map: this.googleMapComponent.map,
            center: this.googleMapComponent.map.getCenter(),
            radius: this.nearbySearchRadius,
            draggable: true,
            editable: true,
        });

        // add listener for radius change
        this.nearbyPointsSearchCircle.addListener('radius_changed', () => {
            this.nearbySearchRadius = this.nearbyPointsSearchCircle?.getRadius();
        });

        // add listener for center change
        this.nearbyPointsSearchCircle.addListener('center_changed', () => {
            const center = this.nearbyPointsSearchCircle?.getCenter() as google.maps.LatLng;
            const nearbySearchCenter: LatLng = {
                lat: center.lat() ?? this.googleMapComponent.map.getCenter().lat(),
                lng: center.lng() ?? this.googleMapComponent.map.getCenter().lng()
            };
            this.nearbySearchCenter = nearbySearchCenter;
        });
    }

    async openChallengeParticipantProgress() {
        await this.setMapDrawer(MapDrawer.ChallengeProgress);
        this.openParticipantProgressModal = true;
    }

    async closeChallengeParticipantProgress() {
        await this.closeMapDrawer();
        this.openParticipantProgressModal = false;
    }

    /// End Nearby Places Calls

    private tagsChanged(e: CustomEvent) {
        this.selectedCategories = e.detail.selectedCategories;
        this.selectedTopTags = e.detail.selectedTopTags;
        this.selectedSubTags = e.detail.selectedSubTags;
        this.selectedTags = e.detail.selectedTags;
        this.keywordsList = e.detail.keywordsList;
    }

    private readonly advancedSearchFilterEvent = async (e: any) => {
        const isDefault = (obj: any) => {
            return obj?.selectedCategories.length === 0 &&
                obj?.selectedTopTags.length === 0 &&
                obj?.selectedSubTags.length === 0 &&
                obj?.selectedTags.tags.length === 0 &&
                obj?.keywordsList.length === 0;
        };

        if (isDefault(e.detail) || e.detail.type === 'FilterChip') {
            this.advancedFilterOn = false;
        } else {
            this.advancedFilterOn = true;
        }

        pointCache.removeFilter();

        this.selectedCategories = e.detail.selectedCategories;
        this.selectedTopTags = e.detail.selectedTopTags;
        this.selectedSubTags = e.detail.selectedSubTags ?? [];
        this.selectedTags = e.detail.selectedTags;
        this.keywordsList = e.detail.keywordsList;

        pointCache.categoryFilterList = this.selectedCategories;
        pointCache.tagFilterList = this.selectedTopTags.map((t) => t.topLevelTag);
        pointCache.tagFilterList = pointCache.tagFilterList.concat(
            this.selectedSubTags.map((t) => t.subTags).flat()
        );

        const categoryFilter = e.detail?.selectedCategories.length > 0 ? categoryFilterFn : (p: GetPointResponse) => true;
        const tagsFilter = this.selectedTags.tags.length > 0 ? tagsFilterFn : (p: GetPointResponse) => true;
        const keywordsFilter = e.detail?.keywordsList.length > 0 ? keywordSearchFn : (p: GetPointResponse) => true;

        pointCache.filterMarkers({
            name: 'FilterChip',
            filterFn: (p: GetPointResponse) =>
                categoryFilter(p, e.detail.selectedCategories) &&
                tagsFilter(p, this.selectedTags) &&
                keywordsFilter(p, e.detail.keywordsList),
        });

        // if it is not a basic filter click, it is probably from advanced filtering
        if (e.detail.type !== 'FilterChip') {
            await this.closeMapDrawer();
        }
    };

    clearAllFiltersClick() {
        pointCache.removeFilter();
        this.advancedFilterOn = false;
        this.selectedCategories = [];
        this.selectedTopTags = [];
        this.selectedSubTags = [];
        this.keywordsList = [];
        this.selectedTags = {
            tags: [],
            operator: CombineOperator.And,
        };
        pointCache.categoryFilterList = [];
        pointCache.tagFilterList = [];
    }

    filterCategoriesOnLoad(selectedCategories: string[]) {
        const categories = topicData.categories;
        const filteredCategories = categories.filter((category) =>
            selectedCategories.includes(category.name.toLowerCase())
        );
        this.selectedCategories = filteredCategories.map((category) => category.name);
        if (this.selectedCategories.length > 0) {
            pointCache.filterMarkers({
                name: 'FilterChip',
                filterFn: (p: GetPointResponse) => categoryFilterFn(p, this.selectedCategories),
            });
            pointCache.categoryFilterList.push(...this.selectedCategories);
            for (const category of this.selectedCategories) {
                logWithGoogleTagAndTopicOrganization(MapComponent.amplitude_callsite, GoogleTagEvent.MAP_CATEGORY_CLICKED, {
                    category_name: category,
                });
            }
        }
    }

    private filterTagsOnLoad(selectedTags: string[]) {
        for (const tag of selectedTags) {
            logWithGoogleTagAndTopicOrganization(MapComponent.amplitude_callsite, GoogleTagEvent.MAP_TAG_CLICKED, {
                tag_name: tag
            });
        }
        const topLevelTagSearches: TopLevelTagSearchType[] = [];
        const subTagSearches: SubTagSearchType[] = [];
        selectedTags.forEach((tagInput) => {
            const tagExists = topicData.allUserTags.find(
                (t) => t.name.toLowerCase() === tagInput.toLowerCase()
            );
            if (tagExists) {
                // See if parent tag exists
                const parentTag = topicData.topLevelUserTags.find((t) =>
                    t.tags?.some((tag) => tag.name === tagExists.name)
                );
                if (parentTag) {
                    // if the parent tag is not already in the subTagSearches array, add it
                    if (!subTagSearches.some((t) => t.topLevelTag === parentTag.name)) {
                        subTagSearches.push({
                            topLevelTag: parentTag.name,
                            subTags: [tagExists.name],
                            operator: CombineOperator.Or
                        });
                    } else {
                        // if the parent tag is already in the subTagSearches array, add the subtag to the subTags array
                        subTagSearches
                            .find((t) => t.topLevelTag === parentTag.name)
                            ?.subTags.push(tagExists.name);
                    }
                } else {
                    // if the parent tag does not exist, add it to the topLevelTagSearches array
                    topLevelTagSearches.push({ topLevelTag: tagExists.name });
                }
            }
        });
        this.selectedTopTags = topLevelTagSearches;
        this.selectedSubTags = subTagSearches;
        this.selectedTags = {
            operator: CombineOperator.And,
            tags: this.selectedTopTags.concat(this.selectedSubTags)
        };
        if (this.selectedTags.tags.length > 0) {
            pointCache.filterMarkers({
                name: 'FilterChip',
                filterFn: (p: GetPointResponse) => tagsFilterFn(p, this.selectedTags),
            });
        }

        pointCache.tagFilterList = selectedTags;
    }

    async addStaticShape() {
        if (!isDefined(this.foucsedShapeHolder)) {
            return;
        }
        this.drawingIsActive = false;
        this.askForShapeType = false;
        await this.setMapDrawer(MapDrawer.EditShape);

        if (isDefined(this.shapeModalContent) !== undefined && isDefined(this.foucsedShapeHolder)) {
            addShapeToMap(this.foucsedShapeHolder.inner, this.googleMapComponent.map);
            this.shapeModalContent.focusedShape = this.foucsedShapeHolder;
            this.shapeModalContent.type = this.foucsedShapeHolder.shape.geojson.type;
        }

    };

    async openUpgradeDialog(featureType: FeatureType) {
        await this.closeMapDrawer();

        this.dispatchEvent(new CustomEvent('open-upgrade-dialog', {
              detail: {
                featureType
              }
         }));
    }

    async openIntercomForMoreAIUses() {
        const message = 'I would like to purchase more AI uses for Proxi.';
        openChatWindow(MapComponent.amplitude_callsite, message);
    }

    async onShowAddToMapModal(selectedPoints: GetPointResponse[]) {
        this.selectedPoints = selectedPoints;
        await this.setMapDrawer(MapDrawer.AddPointsToMap);
    }

    async onOpenCreateRoute(selectedPoints?: GetPointResponse[]) {
        if (isDefined(selectedPoints)) {
            this.selectedPoints = selectedPoints;
        }
        await this.setMapDrawer(MapDrawer.GetRouteFromPoints);
    }

    async openBackgroundShapeEdit(shapeHolder: TopLevelShapeHolder) {
        await this.setMapDrawer(MapDrawer.EditShape);
        // dont open if someone is already editing a different shape
        if (isDefined(this.shapeModalContent) && this.shapeModalContent.focusedShape === undefined && shapeHolder.id !== undefined) {
            this.shapeModalContent.focusedShape = shapeHolder;
        }
        this.closeListOfPoints();
    }

    filterChipsChanged (e: CustomEvent) {
        this.selectedCategories = e.detail.selectedCategories;
        this.selectedTopTags = e.detail.selectedTopTags;
        this.selectedSubTags = e.detail.selectedSubTags;
        // add more of these later as needed
    }

    zoomIn() {
        this.googleMapComponent.map.setZoom((this.googleMapComponent.map.getZoom() as number) + 1);
    }

    zoomOut() {
        this.googleMapComponent.map.setZoom((this.googleMapComponent.map.getZoom() as number) - 1);
    }

    private readonly searchChanged = debounce((e: CustomEvent) => this.searchChangedInternal(e.detail.value ?? ''), 500);

    private searchChangedInternal(searchValue: string) {
        const search = searchValue?.trim().toLocaleLowerCase() ?? '';

        logWithAmplitude(MapComponent.amplitude_callsite, 'Point Search', {
            topic_id: topicData.topicId,
            search,
        });

        pointCache.removeFilter('ListSearch');
        if (search !== '') {
            pointCache.filterMarkers({ name: 'ListSearch', filterFn: (p: GetPointResponse) => pointSearch(p, search) });
            logWithGoogleTagAndTopicOrganization(MapComponent.amplitude_callsite, GoogleTagEvent.MAP_SEARCH, {
                search_term: search,
            });

        }
    }

    onEnableMultiSelection() {
        this.multiSelectionEnabled = true;
        this.selectedPoints = this.highlightedPoint ? [this.highlightedPoint] : [];
        this.googleMapComponent.map.setOptions({
            draggableCursor: "url('/images/multi-select.svg')",
        });
    }

    onDisableMultiSelection() {
        this.multiSelectionEnabled = false;
        this.googleMapComponent.map.setOptions({
            draggableCursor: undefined,
        });
    }

    private get hasDrawerActionContent() {
        if (!this.showOtherDrawerButton) {
            return false;
        }

        return (this.challengeIsHappening || this.challenge?.can_view_challenge_after_end_date === true)
            || (this.electionIsHappening && electionVotingIsHappening(topicData.electionHappeningNow))
            || (this.electionIsHappening && electionNominationsAreHappening(topicData.electionHappeningNow))
            || topicData.topic?.is_addpointer === true
            || topicData.topic?.is_gate_limited === true;
    }

    async onDeselectAllAndClose() {
        this.selectedPoints = [];
        pointCache.points.forEach((p) => {
            const markerHolder = pointCache.getMarker(p._id.$oid);
            revertIconForMarker(markerHolder);
        });
        this.onDisableMultiSelection();
        await delay(0);
        await this.closeListOfPoints();
    }

    async onDeselectPoint(p: GetPointResponse) {
        this.selectedPoints = this.selectedPoints.filter((point) =>
            point._id.$oid !== p._id.$oid
        );
        pointCache.points.forEach((p) => {
            const markerHolder = pointCache.getMarker(p._id.$oid);
            if (
                markerHolder &&
                !this.selectedPoints.find((point) =>
                    point._id.$oid === p._id.$oid
                )
            ) {
                revertIconForMarker(markerHolder);
            }
        });
        if (this.selectedPoints.length === 0) {
            await this.onDeselectAllAndClose();
        }
    }

    render() {
        // set constants
        const header_background_color = topicData.backgroundColor;
        const button_text_color = topicData.textColor;

        // render map
        return html`
            <div class="map__inner-wrapper">
                <div class="sr-only" role="region" aria-label="Accessibility notice">
                    <p>This page contains an interactive map. ${topicData.topic?.disable_list_button !== true
                        ? html`<button class="sr-only-focusable" @click="${async () => await this.setMapDrawer(MapDrawer.MapInfo)}">Browse all ${pointCache.points?.length ?? ''} locations as a text list</button>`
                        : html`Use the map details panel for a text summary of this map.`
                    }</p>
                </div>
                <div class="map-content-wrapper ${this.mapDrawer && !this.isMobile ? 'shrink' : ''}">
                    ${this.isPrintView ? '' : html`
                    <point-drawer id="pointDrawer" .mobilePreview="${this.mobilePreview}" .bottomDrawerHeight="${this.bottomDrawerHeight}" @on-close="${this.onListOfPointsClosed}">
                        <point-card-pagination
                            id="pointCardPaginationEl"
                            .selectedPoints=${this.selectedPoints}
                            .highlightedPoint=${this.highlightedPoint}
                            .previewMode=${this.isUserPreview}
                            .mobilePreview=${this.mobilePreview}
                            .multiSelectionEnabled=${this.multiSelectionEnabled}
                            .standaloneMapView=${this.hidePointCardPaginationOnLoad}
                            .isContainingDrawerOpen=${this.pointDrawer?.isOpened}
                        >
                        </point-card-pagination>
                    </point-drawer>
                    `}
                    ${
                    this.showMap
                        ? html`
                            ${this.hideCategoriesandTags || this.drawingIsActive || (isDefined(this.mapDrawer)&& detectMobileViewport()) ? '' : html`
                                ${this.isInStaticMapMode ?
                                    html`
                                        ${!this.is_map_locked ? html`
                                            <div class="map-filter-chips interact">
                                                <paper-chip
                                                    label="Click To Interact"
                                                    class="custom-chip"
                                                    selectable
                                                    >
                                                </paper-chip>
                                            </div>
                                        ` :
                                        html`
                                            <div class="map-banner-not-subscribed">
                                                <span>
                                                    <b>PROXI ADMIN NOTE</b><br>THIS IS A FREE PREVIEW: UPGRADE OR START A TRIAL FOR INTERACTIVE MAP
                                                </span>
                                            </div>
                                        `}
                                ` : html`
                                    <filter-chips
                                        class="map-filter-chips"
                                        style=${this.pointListOpen && !detectMobileViewport(this.mobilePreview) ? 'left: max(min(468px, 35vw),350px); width: calc(100% - max(min(468px, 35vw),350px));' : ''}
                                        .show=${!this.showNearbyPlacesSearchModal}
                                        .mobilePreview=${this.mobilePreview}
                                        .advancedFilterOn=${this.advancedFilterOn}
                                        .selectedCategories=${this.selectedCategories}
                                        .selectedTopTags=${this.selectedTopTags}
                                        .selectedSubTags=${this.selectedSubTags}
                                        .pointListOpen=${this.pointListOpen}
                                        @open-advanced-filtering=${async () => await this.setMapDrawer(MapDrawer.AdvancedFiltering)}
                                        @clear-all-filters=${this.clearAllFiltersClick}
                                        @filter-chips-changed=${this.filterChipsChanged}
                                        ?hasGptCTA=${true}
                                    >
                                    </filter-chips>`
                                }`
                            }
                            ${!this.isUserPreview ? html`
                                ${this.showSetDefaultZoomCenter && !this.showDrawToolOptions && !this.showNearbyPlacesSearchModal ? html`
                                    <div class="defaultCenterContainer">
                                        <form-button
                                            variant="transparentoutline"
                                            backgroundColor=${palette.accentFeatured}
                                            size="sm"
                                            id="editZoom"
                                            class="desktopOnly"
                                            style="border-radius: 4px; border: solid 0.5px; margin: 0.25rem; z-index:1; --btn-background-color:var(--main-featured-color)"
                                            @click=${this.setDefaultOrientationAndCenter}
                                        >
                                            <mwc-icon class="editButtonIcon">center_focus_strong</mwc-icon>
                                            Set as New Default View
                                        </form-button>
                                    </div>` : ''}`
                                        : ''
                            }
                            ${this.showAddPointButton && !this.isUserPreview && !detectMobileViewport(this.mobilePreview) && !(isDefined(this.mapDrawer) && this.pointListOpen)
                                ? html`<span
                                    class="map-new-point__wrapper ${this.pointListOpen
                                        ? 'map-new-point__wrapper--right'
                                        : ''}
                                        ${topicData.topic?.show_advanced_filter_row === true && !this.showDrawToolOptions && !this.showNearbyPlacesSearchModal && !this.showOverlayImageUpload ? 'map-new-point__lower' : ''}"

                                >
                                    <button
                                        id="addPointButton"
                                        class="map-new-point ${this.showDrawToolOptions || this.showNearbyPlacesSearchModal || this.showOverlayImageUpload ? 'hideButton' : ''}"
                                        @click=${pointCache.pointsRemaining <= 0 ? async () => await this.openUpgradeDialog(FeatureType.PointsPerMap) : this.onPointAdd}
                                    >
                                        <mwc-icon class="map-new-point__icon">add_location</mwc-icon>
                                        <span class="button-text">  Add ${topicData.topic?.point_name ?? 'Point'} </span>
                                    </button>
                                    ${topicData.hasExceptions === IntegrationException.TrudiFord || topicData.hasExceptions === IntegrationException.WilliamEScooter ? html`
                                        <button
                                            class="map-new-point ${this.showDrawToolOptions ? 'hideButton' : ''}"
                                            @click="${async () => await this.startDrawing(google.maps.drawing.OverlayType.POLYLINE, true)}"
                                        >
                                            <mwc-icon class="map-new-point__icon">polyline</mwc-icon>
                                            <span class="button-text"> ${topicData.hasExceptions === IntegrationException.TrudiFord ? 'Highlight Street': 'Shapes'} </span>
                                        </button>
                                    ` : ''}
                                    ${detectMobileViewport(this.mobilePreview) || pointCache.pointsRemaining <= 0 ? '' : html`
                                        ${this.showNearbyPlacesSearchModal ? html`
                                            ${featuresInfo.numberOfUsesOfProxiAIEnabled - (accountInfo.ai_tool_uses_this_month ?? 0) <= 50 && accountInfo.isAuthenticated ? html`
                                                <div class="nearby-search-counter">
                                                    ${accountInfo.ai_tool_uses_this_month ?? 0} / ${featuresInfo.numberOfUsesOfProxiAIEnabled} AI searches used this month.
                                                    <span class="nearby-search-counter__link" @click=${this.openIntercomForMoreAIUses}><span style="text-decoration:underline">Request More</span>.</span>
                                                </div>
                                            ` : ''}
                                            ${accountInfo.isAuthenticated || topicData.hasExceptions === IntegrationException.WelcomeHomeRelocations ? html`
                                                <nearby-search-component class="admin-map-edit-area"
                                                    .searchCircle=${this.nearbyPointsSearchCircle}
                                                    .focusedMarker=${this.focusedNearbySearchResult}
                                                    @close-and-reset=${async () => await this.resetNearbySearchResults(true)}
                                                    @on-new-search-result=${this.onNearbyPlacesFound}
                                                    @on-updated-search-result=${this.onNearbyPlacesUpdated}
                                                    @on-result-hover=${this.setNearbyPlaceFocus}
                                                    @on-open-upgrade-dialog=${async () => await this.openUpgradeDialog(FeatureType.NumberOfUsesOfProxiAI)}
                                                    @reset-nearby-search=${async () => await this.resetNearbySearchResults(false)}
                                                >
                                                </nearby-search-component>
                                            ` : html`
                                                <div class="admin-map-edit-area">
                                                    <span>Sign in to Proxi to use this feature.</span>
                                                    <br>
                                                    <span style="text-decoration: underline; cursor:pointer" @click=${this.closeNearbyPlacesSearchModal} class="admin-map-edit-area__link">Close</span>
                                                </div>
                                            `}
                                        ` : html`
                                            <button
                                                @click=${this.openNearbyPointsSearchDrawer}
                                                class="map-new-point ${this.showDrawToolOptions || this.showOverlayImageUpload ? 'hideButton' : ''}"
                                            >
                                                <mwc-icon class="map-new-point__icon map-new-point__icon--ai">search</mwc-icon>
                                                <span class="button-text">  Search & Add Places </span>
                                            </button>
                                        `}
                                    `}
                                    <button
                                        class="map-new-point ${this.showDrawToolOptions ? 'draw-mode':''} ${this.mapDrawer === MapDrawer.EditShape || this.showNearbyPlacesSearchModal || this.showOverlayImageUpload || topicData.hasExceptions === IntegrationException.WelcomeHomeRelocations ? 'hideButton' : ''}"
                                        @click=${this.toggleShowDrawToolOptions}
                                    >
                                        <mwc-icon class="map-new-point__icon map-new-point__icon--ai">${this.showDrawToolOptions ? 'close':'shape_line'}</mwc-icon>
                                       <span class="button-text">  ${this.showDrawToolOptions ? 'Exit Draw Mode' : 'Add Shape'} </span>
                                    </button>
                                    ${this.mapDrawer === MapDrawer.EditShape || this.showNearbyPlacesSearchModal || this.showOverlayImageUpload || topicData.hasExceptions === IntegrationException.WelcomeHomeRelocations ? '' : html`
                                        <button
                                            class="map-new-point ${this.showDrawToolOptions ? 'hideButton' : ''}"
                                            @click="${async () => await this.onOpenCreateRoute()}"
                                        >
                                            <mwc-icon class="map-new-point__icon">route</mwc-icon>
                                            <span class="button-text"> Route </span>
                                        </button>
                                    `}
                                    ${this.isAdminPortalMobile ? '' : html`
                                        <button
                                            class="map-new-point ${this.showDrawToolOptions || this.showNearbyPlacesSearchModal || topicData.hasExceptions === IntegrationException.WelcomeHomeRelocations ? 'hideButton' : ''}"
                                            @click=${this.toggleShowOverlayImageUpload}
                                        >
                                            <mwc-icon class="map-new-point__icon map-new-point__icon--ai">${this.showOverlayImageUpload ? 'close':'photo_library'}</mwc-icon>
                                            <span class="button-text"> ${this.showOverlayImageUpload ? 'Exit Overlay Editing' : 'Overlay Images On Map'} </span>
                                        </button>
                                    `}
                                </span>`
                                : ''}

                            <!-- dont add dots in front of api-key or additional-map-options - it will break -->
                            ${this.isInStaticMapMode ? html`
                            <div id="mapScreenshotContainer" style="background-image:url('${this.backgroundImage}')">
                                </div>
                            ` : html`
                            <google-map
                                class="${this.drawingIsActive ? 'drawing-map-border' : ''}"
                                id="map"
                                role="region"
                                aria-label="${topicData.topic?.name ?? 'Interactive map'}. Use the list view for keyboard-accessible browsing."
                                latitude="${this.lat}"
                                longitude="${this.lng}"
                                zoom=${this.zoom}
                                api-key="${GOOGLE_KEY}"
                                additional-map-options="${this.additionalMapOptions ?? ''}"
                                min-zoom="1"
                                click-events
                                @google-map-ready="${async () => await this.onMapReady()}"
                                @google-map-click="${this.onMapClick}"
                                @google-map-rightclick="${this.userPointCreateRequestFromLatLng}"
                                @google-map-dblclick="${this.userPointCreateRequestFromLatLng}"
                                @google-map-dragend="${() => {
                                    this.lat = this.googleMapComponent.latitude;
                                    this.lng = this.googleMapComponent.longitude;
                                }}"
                                @zoom-changed="${() => (this.zoom = this.googleMapComponent.zoom)}"
                                @mousewheel="${() => {
                                    this.lat = this.googleMapComponent.latitude;
                                    this.lng = this.googleMapComponent.longitude;
                                }}"
                                drag-events
                                disable-street-view-control
                                disable-map-type-control
                                disable-zoom-control
                                disable-default-ui
                                single-info-window
                            >
                            </google-map>
                            ${this.isPrintView ? '' : html`
                                <div id='controlButtons' class="${detectMobileViewport(this.mobilePreview) && this.pointListOpen ? 'mobile-above-pagination' : ''}">
                                    <div id='zoom-buttons'>
                                        <button
                                                id="zoomInButton"
                                                class="zoomButton"
                                                @click="${this.zoomIn}"
                                                draggable="false"
                                                title="Zoom In"
                                                aria-label="Zoom In"
                                                type="button"
                                                >
                                                <mwc-icon id="zoomInImage">add</mwc-icon>
                                            </button>
                                            <button
                                                id="zoomOutButton"
                                                class="zoomButton"
                                                @click="${this.zoomOut}"
                                                draggable="false"
                                                title="Zoom Out"
                                                aria-label="Zoom Out"
                                                type="button"
                                                >
                                                <mwc-icon id="zoomOutImage">remove</mwc-icon>
                                            </button>
                                    </div>
                                    <button
                                        id="geoButton"
                                        @click="${this.updateCenterToGeolocation}"
                                        draggable="false"
                                        title="Toggle GsPS"
                                        aria-label="Toggle GPS"
                                        type="button"
                                        >
                                        <mwc-icon id="geoImage" class="${this.geolat !== undefined ? 'activeGeo' : ''}">near_me</mwc-icon>
                                        <translated-span class="for-translation">Near Me</translated-span>
                                    </button>
                                    ${inIframe() ? html`
                                        <button
                                            id="geoButton"
                                            @click="${this.clickFullscreen}"
                                            draggable="false"
                                            title="Open Full Screen"
                                            aria-label="Open Full Screen"
                                            type="button"
                                            >
                                            <mwc-icon id="geoImage">${this.isFullScreen ? 'fullscreen_exit' : 'fullscreen'}</mwc-icon>
                                            ${this.isFullScreen ? html`<translated-span class="for-translation">Exit Full Screen</translated-span>` : html`<translated-span class="for-translation">Full Screen</translated-span>`}
                                        </button>
                                    `: ''}
                                </div>
                                ${!pointCache.markersReady && (pointCache.allPoints.length > 0 || !pointCache.isReady) ? html`
                                    <div id='loadingButtonHolder'>
                                        <div
                                            id="loadingButton"
                                            @click="${this.updateCenterToGeolocation}"
                                            draggable="false"
                                            title="Toggle GsPS"
                                            aria-label="Toggle GPS"
                                            type="button"
                                            >
                                            <loading-element
                                                loadingString="Getting ${topicData.topic?.point_name ?? 'Point'}s"
                                                ?horizontal=${true}
                                                ?small=${true}
                                                ></loading-element>

                                        </div>
                                    </div>
                                ` : ''}
                            `}
                        `}
                        `: ''
                    }
                     ${this.drawingIsActive ? html`
                        <div id='drawingButtons'>
                            <span id="drawingButtonsTitle">Drawing Mode is On</span>
                            <span id="drawingButtonsSubTitle">Click on the map to draw.<br />Double click to finish.</span>
                        </div>
                    ` : ''}
                    ${(topicData.topic?.disable_powered_by_proxi === true && featuresInfo.hideAllCommandCenterButtonsEnabled) ? '' : html`
                        <div id="poweredBy" style="color:${topicData.textColor}; background-color:${topicData.backgroundColor}">
                            <span id="proxilink" @click="${async () => await this.onClickOutParams()}"><translated-span>Built with Proxi Maps</translated-span></span>
                        </div>
                    `}
                    <add-point-button
                        id="addPointButton"
                        @open-add-point=${this.onPointAdd}
                        @close-list-of-points=${() => this.closeListOfPoints()}
                        buttonMode='hidden'>
                    </add-point-button>


                    ${
                        detectMobileViewport(this.mobilePreview) && this.mapDrawer !== MapDrawer.AddPoint && !this.showSetDefaultZoomCenter && (topicData.topic?.hide_map_info_drawer !== true || this.hasDrawerActionContent) ? html`
                            <div class="bottom-drawer" id="bottomDrawer" ${ref((el?: Element) => {
                                if (el && el instanceof HTMLElement) {
                                    requestAnimationFrame(() => {
                                        const height = el.offsetHeight;
                                        if (this.bottomDrawerHeight !== height) {
                                            this.bottomDrawerHeight = height;
                                        }
                                    });
                                }
                            })}>
                                ${topicData.topic?.hide_map_info_drawer === true ? '' : html`
                                    <div class="bottom-drawer-btn" role="button" tabindex="0" aria-label="${topicData.topic?.disable_list_button === true ? 'Show map details' : 'Browse locations'}" @click="${async () => await this.setMapDrawer(MapDrawer.MapInfo)}" @keydown="${async (e: KeyboardEvent) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); await this.setMapDrawer(MapDrawer.MapInfo); }}}">
                                        <mwc-icon aria-hidden="true">
                                            keyboard_double_arrow_up
                                        </mwc-icon>
                                        <translated-span>${topicData.topic?.disable_list_button === true ? 'Show Map Details' : 'Browse Locations'}</translated-span>
                                    </div>
                                `}
                                ${this.hasDrawerActionContent ? html`
                                    <div class="bottom-drawer-mobile-btn-group">
                                        ${this.challengeIsHappening || this.challenge?.can_view_challenge_after_end_date === true ? html`
                                            <div class="bottom-drawer-mobile-btn red" style="background-color:${header_background_color}" @click="${async () => await this.onClickActivateChallenge()}">
                                                <mwc-icon style="color:${button_text_color}">star_outline</mwc-icon>
                                                ${challengeData.isType(ChallengeType.Passport) ? html`
                                                <translated-span style="color:${button_text_color}">Passport</translated-span>
                                                ` : challengeData.isType(ChallengeType.Hunt) ? html`
                                                <translated-span style="color:${button_text_color}">Scavenger Hunt</translated-span>
                                                ` : challengeData.isType(ChallengeType.Trivia) ? html`
                                                <translated-span style="color:${button_text_color}">Trivia</translated-span>
                                                ` : challengeData.isType(ChallengeType.Guide) ? html`
                                                <translated-span style="color:${button_text_color}">Guide</translated-span>
                                                ` : challengeData.isType(ChallengeType.Treasure) ? html`
                                                <translated-span style="color:${button_text_color}">Treasure Hunt</translated-span>
                                                ` : ''}
                                            </div>
                                        ` : ''}
                                        ${this.electionIsHappening && electionVotingIsHappening(topicData.electionHappeningNow) ? html`
                                            <div class="bottom-drawer-mobile-btn red" style="background-color:${header_background_color}" @click="${async () => await this.setMapDrawer(MapDrawer.ElectionBallot)}">
                                                <mwc-icon style="color:${button_text_color}">check_box</mwc-icon><br>
                                                <translated-span style="color:${button_text_color}">Vote</translated-span>
                                            </div>
                                        ` : ''}
                                        ${this.electionIsHappening && electionNominationsAreHappening(topicData.electionHappeningNow) ? html`
                                            <div class="bottom-drawer-mobile-btn green" style="background-color:${header_background_color}" @click="${async () => await this.setMapDrawer(MapDrawer.Nomination)}">
                                                <mwc-icon style="color:${button_text_color}">add_location</mwc-icon>
                                                <translated-span style="color:${button_text_color}">Nominate</translated-span>
                                            </div>
                                        ` : ''}
                                        ${topicData.topic?.is_addpointer === true ? html`
                                            ${pointCache.pointsRemaining <= 0 && topicData.isWriter ? html`
                                                <div class="bottom-drawer-mobile-btn gray" @click="${async () => await this.openUpgradeDialog(FeatureType.PointsPerMap)}">
                                                    <mwc-icon>add_location</mwc-icon>
                                                    <translated-span>Add ${topicData.topic.point_name ?? 'Point'}</translated-span>
                                                </div>
                                            ` : html`
                                                ${topicData.electionHappeningNow && electionNominationsAreHappening(topicData.electionHappeningNow) ? '' : html`
                                                    <div class="bottom-drawer-mobile-btn green" style="background-color:${header_background_color}"  @click="${async () => await this.setMapDrawer(MapDrawer.AddPoint)}">
                                                        <mwc-icon style="color:${button_text_color}">add_location</mwc-icon>
                                                        <translated-span style="color:${button_text_color}">Add ${topicData.topic.point_name ?? 'Point'}</translated-span>
                                                    </div>
                                                `}
                                                ${topicData.hasExceptions === IntegrationException.TrudiFord || topicData.hasExceptions === IntegrationException.WilliamEScooter ? html`
                                                    <div class="bottom-drawer-mobile-btn green" style="background-color:${header_background_color}" @click="${async () => await this.startDrawing(google.maps.drawing.OverlayType.POLYLINE, true)}">
                                                        <mwc-icon style="color:${button_text_color}">polyline</mwc-icon>
                                                        <span style="color:${button_text_color}">${topicData.hasExceptions === IntegrationException.TrudiFord ? 'Highlight Street': 'Add Shape'}</span>
                                                    </div>
                                                ` : ''}
                                            `}
                                        ` : ''}
                                        ${topicData.topic?.is_gate_limited === true ? html`
                                            <div class="bottom-drawer-mobile-btn blue" style="background-color:${header_background_color}" @click="${async () => await this.setMapDrawer(MapDrawer.MapInfo)}">
                                                <mwc-icon style="color:${button_text_color}">lock_outline</mwc-icon>
                                                <translated-span style="color:${button_text_color}">Get Access</translated-span>
                                            </div>
                                        ` : ''}
                                    </div>
                                ` : ''}
                            </div>
                        ` : ''}
                </div>
                ${detectMobileViewport(this.mobilePreview) || this.isPrintView ? '' : html`
                    <div class="${this.mapDrawer === MapDrawer.MapInfo && !this.mobilePreview ? '' : 'hide'} ${this.hasDrawerActionContent ? '' : 'limited'}">
                            <div class="expand-creator-info-btn-group">
                                ${(this.isAdminPortalDesktop || this.isAdminPortalMobile) && !this.isUserPreview || topicData.topic?.hide_header !== true ? '' : html`
                                    ${this.challengeIsHappening || this.challenge?.can_view_challenge_after_end_date === true ? html`
                                        <div class="expand-creator-info-btn red" style="background-color:${header_background_color}"  @click="${async () => await this.onClickActivateChallenge()}">
                                            <mwc-icon style="color:${button_text_color}">star_outline</mwc-icon><br>
                                            <p class="expand-creator-info-text" style="color:${button_text_color}">
                                                ${challengeTypeDisplayName(this.challenge)}
                                            </p>
                                        </div>
                                    ` : ''}
                                    ${this.electionIsHappening ? html`
                                        <div class="expand-creator-info-btn" style="background-color:${header_background_color}"  @click="${async () => await this.setMapDrawer(MapDrawer.ElectionBallot)}">
                                            <mwc-icon style="color:${button_text_color}">star_outline</mwc-icon>
                                            <translated-span style="color:${button_text_color}">Vote</translated-span>
                                        </div>
                                    ` : ''}
                                    ${topicData.topic?.is_addpointer ? html`
                                        ${pointCache.pointsRemaining <= 0 && topicData.isWriter ? html`
                                            <div class="expand-creator-info-btn gray" @click="${async () => await this.openUpgradeDialog(FeatureType.PointsPerMap)}">
                                                <mwc-icon>add_location</mwc-icon>
                                                <p class="expand-creator-info-text"><translated-span>Add ${topicData.topic.point_name ?? 'Point'}</translated-span></p>
                                            </div>
                                        ` : html`
                                            <div class="expand-creator-info-btn green" style="background-color:${header_background_color}"  @click="${async () => await this.setMapDrawer(MapDrawer.AddPoint)}">
                                                <mwc-icon style="color:${button_text_color}">add_location</mwc-icon>
                                                <p class="expand-creator-info-text" style="color:${button_text_color}"><translated-span>Add ${topicData.topic.point_name ?? 'Point'}</translated-span></p>
                                            </div>
                                            ${topicData.hasExceptions === IntegrationException.TrudiFord || topicData.hasExceptions === IntegrationException.WilliamEScooter ? html`
                                                <div class="expand-creator-info-btn green" style="background-color:${header_background_color}" @click="${async () => await this.startDrawing(google.maps.drawing.OverlayType.POLYLINE, true)}">
                                                    <mwc-icon style="color:${button_text_color}">add_location</mwc-icon>
                                                    <p class="expand-creator-info-text" style="color:${button_text_color}">${topicData.hasExceptions === IntegrationException.TrudiFord ? 'Highlight Street': 'Add Shape'}</p>
                                                </div>
                                            ` : ''}
                                        `}
                                    ` : ''}
                                `}
                                ${(this.hasDrawerActionContent || !this.pointListOpen) && topicData.topic?.hide_map_info_drawer !== true && (this.mapDrawer === MapDrawer.MapInfo || topicData.topic?.hide_header === true) ? html`
                                    <div class="expand-creator-info-btn" role="button" tabindex="0" aria-label="${this.mapDrawer === MapDrawer.MapInfo ? (topicData.topic?.disable_list_button === true ? 'Hide map details' : 'Hide location list') : (topicData.topic?.disable_list_button === true ? 'Show map details' : 'Browse locations')}" style="background-color:${header_background_color}" @click="${this.setMapDrawer.bind(this, MapDrawer.MapInfo)}" @keydown="${(e: KeyboardEvent) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); void this.setMapDrawer(MapDrawer.MapInfo); }}}">
                                        ${this.mapDrawer === MapDrawer.MapInfo ? html`
                                            <mwc-icon style="color:${button_text_color}" aria-hidden="true">keyboard_double_arrow_right</mwc-icon>
                                            <p class="expand-creator-info-text" style="color:${button_text_color}"><translated-span>${topicData.topic?.disable_list_button === true ? 'Hide Map Details' : 'Hide Location List'}</translated-span></p>
                                        ` : html`
                                            <mwc-icon style="color:${button_text_color}" aria-hidden="true">
                                                keyboard_double_arrow_left
                                            </mwc-icon>
                                            <p class="expand-creator-info-text" style="color:${button_text_color}"><translated-span>${topicData.topic?.disable_list_button === true ? 'Show Map Details' : 'Browse Locations'}</translated-span></p>
                                        `}
                                    </div>
                                ` : ''}
                            </div>
                    </div>
                `}
                ${this.isPrintView ? '' : html`
                    <div class="map-drawer ${this.mapDrawer ? 'open' : ''} ${this.mobilePreview ? 'map-drawer_mobile_preview' : ''}">
                        ${this.renderDrawerContent()}
                    </div>
                `}
                ${this.renderPopUpContent()}
            </div>
            ${organizationInfo.isReady && topicData.isReady ? html`
                <mwc-dialog id="teamAccessComponent" class="dialog" hideActions>
                    <modal-dialog @close=${this.teamAccessClose}>
                        <manage-team-access-component
                            slot="body"
                            .isCreating=${this.isCreating}
                            @closed=${this.teamAccessClose}
                        >
                        </manage-team-access-component>
                    </modal-dialog>
                </mwc-dialog>
            ` : ''}
        <error-toast id="errorToast"></error-toast>`;
    }

    async openPointFromEmailCapture(customEvent: CustomEvent) {
        const pointId = customEvent.detail?.pointId;
        if (isDefined(pointId)) {
            const point = pointCache.allPoints.find(p => p._id.$oid === pointId);
            if (isDefined(point)) {
                await this.onClickPoint(point);
            }
        }
    }

    renderDrawerContent() {
        const email = undefinedIfEmpty(accountInfo.email) ?? undefinedIfEmpty(getFromLocalStorage('email'));
        switch (this.mapDrawer) {
            // case MapDrawer.PointCardList:
            //     return html`
            //         <map-drawer-component @on-close="${this.closeListOfPoints}">
            //             <point-card-pagination
            //                 id="pointCardPaginationEl"
            //                 class="inner_desktop_drawer_content"
            //                 .selectedPoints=${this.selectedPoints}
            //                 .highlightedPoint=${this.highlightedPoint}
            //                 .previewMode=${this.isUserPreview}
            //                 .mobilePreview=${this.mobilePreview}
            //                 .multiSelectionEnabled=${this.multiSelectionEnabled}
            //                 .standaloneMapView=${this.hidePointCardPaginationOnLoad}
            //             >
            //             </point-card-pagination>
            //         </map-drawer-component>
            //     `;
            case MapDrawer.AddPoint:
                return html`
                    ${topicData.topic?.add_point_customization?.email_first === true && !isDefined(email) ? html`
                        <map-drawer-component
                            @on-close="${async () => {await this.closeMapDrawer();}}"
                            .title="Provide Your Email to Add a ${topicData.topic?.point_name} to ${topicData.name}"
                        >
                            <enter-email-component class="inner_desktop_drawer_content" @email-updated="${async() => await this.setMapDrawer(MapDrawer.AddPoint)}" .requireVerification="${topicData.topic?.add_point_customization?.verify_email === true}">
                            </enter-email-component>
                        </map-drawer-component>
                    ` : html`
                        <map-drawer-component
                            @on-close="${async () => {await this.closeMapDrawer();}}"
                            .title="${topicData.topic?.point_name ?? 'Point'} Form"
                            .topLeftIcon="${this.addPointElement?.iconPreview}"
                        >
                            <add-edit-point-component
                                id="addPointElement"
                                class="inner_desktop_drawer_content"
                                .userSelectedLatLng="${this.userSelectedLatLng}"
                                .userDrawnShapeGeometry="${this.foucsedShapeHolder}"
                                .editMode=${false}
                                bypassGoogleKey
                                hideTitle
                                @close-point-modal="${async () => {
                                    this.foucsedShapeHolder = undefined;
                                    await this.closeMapDrawer();
                                }}"
                                @open-point-modal="${() => {this.mapDrawer=MapDrawer.AddPoint;}}">
                            </add-edit-point-component>
                        </map-drawer-component>
                    `}
                `;
            case MapDrawer.EditPoint:
                return html`
                    <map-drawer-component
                        @on-close="${async () => {await this.closeMapDrawer(); void this.closeListOfPoints();}}"
                        .title="${topicData.topic?.point_name ?? 'Point'} Edit Form"
                        .topLeftIcon="${this.editPointElement?.iconPreview}"
                        >

                        <add-edit-point-component
                            id="editPointElement"
                            class="inner_desktop_drawer_content"
                            .point=${this.focusedPoint}
                            .userSelectedLatLng="${this.userSelectedLatLng}"
                            .locationBeforeDrag="${this.locationBeforeDrag}"
                            .dragEndView=${isDefined(this.locationBeforeDrag)}
                            .userDrawnShapeGeometry="${this.foucsedShapeHolder}"
                            bypassGoogleKey
                            hideTitle
                            @close-point-modal="${async () => {
                                this.focusedPoint = undefined;
                                this.foucsedShapeHolder = undefined;
                                await this.closeMapDrawer();
                                this.closeListOfPoints();
                            }}"
                            @open-point-modal="${() => {this.mapDrawer=MapDrawer.EditPoint;}}"
                            >
                        </add-edit-point-component>
                    </map-drawer-component>
                `;
            case MapDrawer.MapInfo:
                return html`
                    <map-drawer-component @on-close="${this.closeCreatorInfoDrawer}" .title="${topicData.topic?.disable_list_button === true ? 'Map Details' : 'Browse Locations'}">
                        <creator-info-component
                            class="inner_desktop_drawer_content"
                            .creator_profile_id="${this.creator_profile_id}"
                            .isUserPreview=${this.isUserPreview}
                            .mobilePreview=${this.mobilePreview}
                            @on-close="${this.closeMapDrawer}"
                            @on-search-changed="${this.searchChanged}"
                        >
                        </creator-info-component>
                    </map-drawer-component>
                `;
            case MapDrawer.ElectionBallot:
                return html`
                    <map-drawer-component @on-close="${this.closeElectionModal}" .title="${this.election?.name ?? ''}" .mobileExpanded=${true}>
                        <election-form-component
                            class="inner_desktop_drawer_content"
                            id="electionForm"
                            .open="${this.open_election}"
                            .pendingVote="${this.pendingVote}"
                            .showEmailConfirm="${this.showEmailConfirm}"
                            @on-close="${this.closeElectionModal}"
                        ></election-form-component>
                    </map-drawer-component>
                `;
            case MapDrawer.Nomination:
                return html`
                    <map-drawer-component @on-close="${this.closeMapDrawer}" .title="${this.election?.name ?? ''} Nominations" .mobileExpanded=${true}>
                        <nomination-component
                            class="inner_desktop_drawer_content"
                            id="nominationForm"
                            isInMap
                            @on-close="${this.closeMapDrawer}"
                        ></nomination-component>
                    </map-drawer-component>
                `;
            case MapDrawer.ChallengeCheckIn:
                return html`
                    <map-drawer-component
                        .coverImage="${challengeData.challenge?.registration_settings?.cover_image_url}"
                        .coverImageLogo="${challengeData.challenge?.registration_settings?.logo_url ?? ''}"
                        .coverImageLogoBackground=${challengeData.challenge?.registration_settings?.show_logo_background === true}
                        .coverImageMaxHeight=${'100px'}
                        @on-close="${this.closeChallengeModal}"
                        .title="${this.challenge?.name ?? ''}"
                        .mobileExpanded=${true}
                        .fullHeightOnExpand=${true}
                    >
                        <checkin-challenge-component
                            class="inner_desktop_drawer_content"
                            id="challengeCheckIn"
                            .isInMap="${true}"
                            .open="${this.open_checkin_challenge}"
                            .pendingCheckinPoint="${this.pendingCheckinPoint}"
                            .showEmailConfirm="${this.showEmailConfirm}"
                            @on-update-username="${this.updateUserName}"
                            @on-close="${this.closeChallengeModal}"
                            @close-after-checkin="${(e: CustomEvent) => {
                                // When the check-in earns a reward, runUpdatesAfterSuccessfulCheckin
                                // has already opened the award announcement drawer via setMapDrawer.
                                // Closing here would dismiss the freshly-opened award modal.
                                if ((e.detail?.newAwards ?? []).length === 0) {
                                    void this.closeChallengeModal();
                                }
                            }}"
                        ></checkin-challenge-component>
                    </map-drawer-component>
                `;
            case MapDrawer.ChallengeProgress:
                return html`
                    <map-drawer-component .coverImage="${challengeData.challenge?.registration_settings?.cover_image_url}"
                    .coverImageLogo="${challengeData.challenge?.registration_settings?.logo_url ?? ''}"
                    .coverImageLogoBackground=${challengeData.challenge?.registration_settings?.show_logo_background === true}
                    .coverImageMaxHeight=${'120px'}
                    @on-close="${this.closeChallengeParticipantProgress}" .title=${this.challenge?.name ?? ''}>
                        <challenge-page
                            id="challengePageComponent"
                            inner_content_only
                            style="display: flex; flex-direction: column; gap:10px;"
                            class="inner_desktop_drawer_content"
                            ></challenge-page>
                    </map-drawer-component>
                `;
            case MapDrawer.AdvancedFiltering:
                return html`
                    <map-drawer-component .title=${topicData.topic?.text_advanced_filters ?? 'Advanced Filtering'} @on-close="${this.closeMapDrawer}">
                            <advanced-filtering-modal
                                id="advancedFiltering"
                                class="inner_desktop_drawer_content"
                                @on-advanced-search=${this.advancedSearchFilterEvent}
                                .selectedCategories=${this.selectedCategories}
                                .selectedTopTags=${this.selectedTopTags}
                                .selectedSubTags=${this.selectedSubTags}
                                .selectedTags=${this.selectedTags}
                                .keywordsList=${this.keywordsList}
                                @on-tags-changed=${this.tagsChanged}
                                @clear-all-filters=${this.clearAllFiltersClick}
                                >
                            </advanced-filtering-modal>
                    </map-drawer-component>
                `;
            case MapDrawer.EmailCaptureMobile:
                return html`
                    <map-drawer-component .coverImage="${this.currentPopUp?.header_logo_url}" noHeader=${true} @on-close="${this.dismissEmailCaptureModal}" .title="" .backgroundColor=${this.currentPopUp?.background_color ?? DEFAULT_EMAIL_COLLECTION_POPUP.background_color}>
                        <email-capture-modal class="inner_desktop_drawer_content" id="emailCapturePopUp" @open-point=${this.openPointFromEmailCapture}
                            .popUp=${this.currentPopUp}
                            .userLat=${this.geolat}
                            .userLng=${this.geolng}
                            @close-modal=${this.closeEmailCaptureModal}
                            >

                        </email-capture-modal>
                    </map-drawer-component>
                `;
        case MapDrawer.PostSubmissionPopUpMobile:
                return html`
                    <map-drawer-component @on-close="${this.dismissEmailCaptureModal}" .title=${topicData.postPointSubmissionPopUp?.pop_up_header ?? DEFAULT_EMAIL_COLLECTION_POPUP.pop_up_header} .backgroundColor=${topicData.postPointSubmissionPopUp?.background_color ?? DEFAULT_EMAIL_COLLECTION_POPUP.background_color}>
                        <email-capture-modal class="inner_desktop_drawer_content" id="emailCapturePopUp" @open-point=${this.openPointFromEmailCapture}
                            .popUp=${topicData.postPointSubmissionPopUp}
                            @close-modal=${this.closeEmailCaptureModal}
                            >

                        </email-capture-modal>
                    </map-drawer-component>
                `;
            case MapDrawer.EditShape:
                return html`
                    <map-drawer-component @on-close="${async() => {await this.shapeModalContent?.reset(); await this.shapeModalContent?.reset(); await this.closeMapDrawer();}}" .title="${this.shapeModalContent?.focusedShape ? 'Edit Shape' : 'Edit Shapes'}">
                        <edit-shape-modal
                            id="shapeModalContent"
                            class="inner_desktop_drawer_content"
                            type="Polygon"
                            hasEntitlement=${featuresInfo.customShapesEnabled}
                            @open-upgrade-dialog=${async () => await this.openUpgradeDialog(FeatureType.CustomShapes)}
                        >
                        </edit-shape-modal>
                    </map-drawer-component>
                `;
            case MapDrawer.EditGeoJson:
                return html`
                    <map-drawer-component @on-close="${async() => {await this.shapeModalContent?.reset(); await this.closeMapDrawer();}}" .title="${'Add GeoJson'}">
                        <edit-shape-modal
                            id="shapeModalContent"
                            class="inner_desktop_drawer_content"
                            ?geoJsonOnlyMode=${true}
                            hasEntitlement=${featuresInfo.customShapesEnabled}
                            @open-upgrade-dialog=${async () => await this.openUpgradeDialog(FeatureType.CustomShapes)}
                        >
                        </edit-shape-modal>
                    </map-drawer-component>
                `;
            case MapDrawer.ChallengeAwardAnnouncement:
                return html`
                    <map-drawer-component @on-close="${this.closeMapDrawer}" .title="${'New Award!'}">
                        <challenge-award-announcement
                            class="inner_desktop_drawer_content"
                            .challengeReward="${this.newRewards}"
                        ></challenge-award-announcement>
                    </map-drawer-component>
                `;
            case MapDrawer.ChallengeUncheck:
                return html`
                <map-drawer-component @on-close="${this.closeChallengeUncheckConfirmModal}" .title="Confirm ${this.challenge?.button_text} Removal">
                        <challenge-uncheck-confirm-modal
                            @on-confirm="${this.handleChallengeUncheckConfirm}"
                            class="inner_desktop_drawer_content"
                            @on-cancel="${this.closeChallengeUncheckConfirmModal}"
                        ></challenge-uncheck-confirm-modal>
                    </map-drawer-component>
                `;
            case MapDrawer.PointShare:
                return html`
                    <map-drawer-component @on-close="${this.closeMapDrawer}" .title="${'Share Point'}">
                        <map-sharing-component
                            class="inner_desktop_drawer_content"
                            .isPointLink="${true}"
                            socialMediaShareImage="${ifDefined(topicData.topic?.custom_social_media_image)}"
                            viewonlyLink="${ifDefined(this.pointUrl)}"
                        ></map-sharing-component>
                    </map-drawer-component>
                `;
            case MapDrawer.ShareMap:
                return html`
                    <map-drawer-component @on-close="${this.closeMapDrawer}" .title="${'Share Map'}">
                        <map-sharing-component
                            class="inner_desktop_drawer_content"
                            socialMediaShareImage="${ifDefined(topicData.topic?.custom_social_media_image)}"
                            viewonlyLink="${ifDefined(topicData.publicShareLink)}"
                        ></map-sharing-component>
                    </map-drawer-component>
                `;
            case MapDrawer.SendToPhone:
                return html`
                    <map-drawer-component @on-close="${this.closeMapDrawer}" .title="${'Send To Phone'}">
                        <send-map-to-phone-modal
                            class="inner_desktop_drawer_content"
                            .qrCodeLink=${topicData.publicQRCode}
                        >
                        </send-map-to-phone-modal>
                    </map-drawer-component>
                `;
            case MapDrawer.SendToPhoneHomescreen:
                return html`
                    <map-drawer-component @on-close="${this.closeMapDrawer}" .title="${''}">
                        <div class="inner_desktop_drawer_content" style="padding: 1em; overflow-y: auto; max-height: calc(100vh - 100px);">
                            <div style="padding: 1em; border-radius: 8px;">
                                <div style="display: flex; gap: 1em; margin-bottom: 0.75em;">
                                    ${topicData.topic?.share_settings?.phone_icon_large ?? topicData.topic?.header_logo ? html`
                                        <div style="flex-shrink: 0;">
                                            <img
                                                src="${topicData.topic?.share_settings?.phone_icon_large ?? topicData.topic?.header_logo}"
                                                alt="App Icon"
                                                style="margin-bottom: 1rem; background-color:${topicData.backgroundColor}; width: 60px; height: 60px; border-radius: 12px; object-fit: contain; box-shadow: 0 4px 12px rgba(0,0,0,0.3);"
                                            />
                                            <form-button
                                                variant="outline"
                                                size="xs"
                                                ?vertical="${true}"
                                                @click="${async () => {
                                                    this.showHomeScreenVideo = !this.showHomeScreenVideo;
                                                    if (this.showHomeScreenVideo) {
                                                        await this.updateComplete.then(() => {
                                                            const videoContainer = this.shadowRoot?.querySelector('.home-screen-video-container');
                                                            videoContainer?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                                                        });
                                                }}}"
                                                style="width: 100%; background: rgba(255,255,255,0.2); color: white; border-color: rgba(255,255,255,0.4);"
                                            >
                                                <mwc-icon style="--mdc-icon-size: 1rem; margin-right: 0.25em;">${this.showHomeScreenVideo ? 'videocam_off' : 'videocam'}</mwc-icon>
                                                ${this.showHomeScreenVideo ? 'Hide' : 'Watch'} Video
                                            </form-button>
                                        </div>
                                    ` : ''}
                                    <div style="flex: 1; min-width: 0;">
                                        <div style="display: flex; align-items: center; gap: 0.5em; margin-bottom: 0.5em;">
                                            <mwc-icon style="--mdc-icon-size: 1rem;">phone_iphone</mwc-icon>
                                            <h3 style="margin: 0; font-size: .9rem; font-weight: 600;">Add to Home Screen</h3>
                                        </div>

                                        <p style="margin: 0; font-size: 0.7rem; opacity: 0.95; line-height: 1.2;">
                                            Get quick access with an app-like experience
                                        </p>

                                        <div style="background: rgba(255,255,255,0.15); padding: 0.75em; border-radius: 6px; margin-bottom: 0.75em; backdrop-filter: blur(10px);">
                                            <ol style="margin: 0; padding-left: 1.25em; font-size: 0.7rem; line-height: 1.1;">
                                                <li>Tap <mwc-icon style="--mdc-icon-size:0.9rem; vertical-align: middle;">ios_share</mwc-icon> or <mwc-icon style="--mdc-icon-size:0.9rem; vertical-align: middle;">more_vert</mwc-icon></li>
                                                <li>Select "Add to Home Screen"</li>
                                                <li>Tap "Add"</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>

                                ${this.showHomeScreenVideo ? html`
                                    <div class="home-screen-video-container" style="margin-top: 0.75em; border-radius: 6px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.3); aspect-ratio: 9/16; max-height: 400px; max-width: 225px; margin-left: auto; margin-right: auto;">
                                        <iframe
                                            width="100%"
                                            height="100%"
                                            src="${/android/i.test(navigator.userAgent)
                                                ? 'https://www.youtube.com/embed/8uwQc4oPrCc'
                                                : 'https://www.youtube.com/embed/qcVSGyBhzek?si=gg7MyQNk-WTcbULY&start=20'}"
                                            title="Add to Home Screen Tutorial"
                                            frameborder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen
                                            style="display: block;"
                                        ></iframe>
                                    </div>
                                ` : ''}
                            </div>
                        </div>
                    </map-drawer-component>
                `;
            case MapDrawer.AddPointsToMap:
                return html`
                <map-drawer-component @on-close="${this.closeMapDrawer}" .title="${'Add To Map'}">
                    <add-point-to-map-component
                        class="inner_desktop_drawer_content"
                        .points=${this.selectedPoints}
                        @close-modal="${this.closeMapDrawer}"
                    >
                    </add-point-to-map-component>
                </map-drawer-component>
                `;
            case MapDrawer.GetRouteFromPoints:
                return html`
                    <map-drawer-component @on-close="${this.closeRouteComponent}" .title="${'Get Route'}">
                        <get-route-component
                            id="optimizedRouteComponent"
                            class="inner_desktop_drawer_content"
                            @open-upgrade-dialog=${async (e:CustomEvent) => await this.openUpgradeDialog(FeatureType.NumberOfUsesOfRoutes)}
                            .points="${this.selectedPoints}"
                            @close-modal="${this.closeRouteComponent}"
                        >
                        </get-route-component>
                    </map-drawer-component>
                `;
            case MapDrawer.OverlayEditor:
                return html`
                    <map-drawer-component @on-close="${this.closeMapDrawer}" .title="${'Overlay Editor'}">
                        <map-overlay-editor
                            class="inner_desktop_drawer_content"
                            .drawnOverlays=${this.drawnOverlays}
                            @open-upgrade-dialog=${async (e:CustomEvent) => await this.openUpgradeDialog(e.detail.featureType)}
                            @refresh-overlays=${this.refreshOverlays}
                        >
                        </map-overlay-editor>
                    </map-drawer-component>
                `;
        }
    }

    renderPopUpContent() {
        switch(this.mapPopUp) {
            case MapPopUp.EmailCaptureDesktop:
                return html`
                    <mwc-dialog id="popUp" class="dialog" hideActions open>
                        <modal-dialog @close=${this.dismissEmailCaptureModal} size="md">
                            <div slot="body">
                                <div id="popUpContent">
                                    <email-capture-modal class="inner_desktop_drawer_content" id="emailCapturePopUp" @close-modal=${this.closeEmailCaptureModal}
                                        .popUp=${this.currentPopUp}
                                        .userLat=${this.geolat}
                                        .userLng=${this.geolng}
                                        @open-point=${this.openPointFromEmailCapture}
                                    ></email-capture-modal>
                                </div>
                            </div>
                        </modal-dialog>
                    </mwc-dialog>
                `;
            case MapPopUp.PostSubmissionPopUpDesktop:
                return html`
                    <mwc-dialog id="popUp" class="dialog" hideActions open>
                        <modal-dialog @close=${this.dismissEmailCaptureModal} size="md">
                            <div slot="body">
                                <div id="popUpContent">
                                    <email-capture-modal class="inner_desktop_drawer_content" id="emailCapturePopUp" @close-modal=${this.closeEmailCaptureModal} .popUp=${topicData.postPointSubmissionPopUp}></email-capture-modal>
                                </div>
                            </div>
                        </modal-dialog>
                    </mwc-dialog>
                `;
        }
    }

    static get styles() {
        return css`
            :host {
                overflow: none;
            }

            .sr-only {
                position: absolute;
                width: 1px;
                height: 1px;
                padding: 0;
                margin: -1px;
                overflow: hidden;
                clip: rect(0, 0, 0, 0);
                white-space: nowrap;
                border: 0;
            }

            .sr-only-focusable {
                background: #000;
                color: #fff;
                padding: 0.5rem 1rem;
                border: 2px solid #fff;
                border-radius: 4px;
                font-size: 0.875rem;
                cursor: pointer;
            }

            .sr-only-focusable:focus {
                position: fixed;
                top: 10px;
                left: 50%;
                transform: translateX(-50%);
                z-index: 9999;
                width: auto;
                height: auto;
                clip: auto;
                overflow: visible;
                white-space: normal;
            }

            .map__inner-wrapper {
                width: 100%;
                height: 100%;
                display: flex;
                overflow: hidden;
            }

            .map-content-wrapper {
                width: 100%;
                transition: width 0.5s ease-in-out;
            }

            .map-content-wrapper.shrink {
                width: calc(100% - max(30vw, 350px));
            }

            .map-drawer {
                position: absolute;
                right: 0;
                width: 30vw;
                min-width: 350px;
                height: 100%;
                background-color: var(--theme-white-color);
                transform: translateX(100%);
                transition: transform 0.5s ease-in-out;
                display:flex;
                z-index: 4;
                border-radius:10px 0 0 10px;
            }

            .map-drawer.open {
                transform: translateX(0);
                box-shadow: rgba(0, 0, 40, 0.08) -1px 0px 2px 0px, rgba(0, 0, 40, 0.08) -6px 0px 10px 0px;
                border-left: 1px solid rgb(236, 236, 236);
            }

            .map-drawer.limited {
                max-height: calc(100vh - 12rem);
            }

            .map-drawer-preview {
                max-height: calc(100vh - 15rem);
            }

            .map-drawer_mobile_preview {
                transform: translateY(100%);
                width: 100%;
                min-width: unset;
                left:0;
                bottom:0;
                height:unset;
                max-height:calc(100% - 50px);
                background-color: transparent;
                transition: transform 0.3s ease-in-out;
            }

            .map-drawer_mobile_preview.open {
                transform: translateY(0);
                border-radius: 0;
                transition: transform 0.3s ease-in-out;
            }

            .inner_desktop_drawer_content {
                flex:1;
                width:calc(max(30vw, 350px) - 40px);
            }

            @keyframes slideIn {
                0% { transform: translateX(100%); }
                100% { transform: translateX(0); }
            }

            @keyframes slideOut {
                0% { transform: translateX(0); }
                100% { transform: translateX(100%); }
            }

            .bottom-drawer {
                position: absolute;
                z-index: 1;
                bottom: 0;
                width: 100%;
                display: flex;
                flex-direction: column;
                box-sizing: border-box;
                background: white;
                padding: 0.5rem;
                border-radius: 0.5rem 0.5rem 0 0;
                box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
            }

            .bottom-drawer-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 0.5rem;
                padding-bottom: 0.5rem;
                font-size: 12px;
                border-bottom: 1px solid var(--theme-border-color);
            }


            .bottom-drawer-mobile-btn-group {
                display: flex;
                gap: 0.5rem;
                padding: 0.5rem;
            }

            .bottom-drawer-mobile-btn {
                flex: 1;
                box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                padding: 0.25rem;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 0.5rem;
            }

            .map-new-point__wrapper {
                position: absolute;
                z-index: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                box-sizing: border-box;
                top: 100px;
                left: 10px;
                box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
                cursor: pointer;
                font-size: 0.7rem;
                --mdc-icon-size: 16px;
                cursor: pointer;
                user-select: none;
            }

            .map-new-point__wrapper > *:first-child {
                border-top-left-radius: 4px;
                border-top-right-radius: 4px;
            }

            .drawing-map-border {
                box-sizing: border-box;
                border: 10px solid var(--main-featured-color);
            }

            .map-new-point__wrapper > *:last-child {
                border-bottom-left-radius: 4px;
                border-bottom-right-radius: 4px;
            }

            .map-new-point__lower {
                top: 125px;
            }

            .map-new-point__wrapper--right {
                right: 10px;
                left: unset;
            }

            .hidden_creator_drawer {
                display: none;
            }

            .map-new-point {
                display: flex;
                flex-direction: column;
                align-items: center;
                color: var(--theme-input-color);
                width: 60px;
                background-color: var(--main-featured-color);
                border: 0;
                padding: 8px;
                cursor: pointer;
            }

            .map-new-point:hover {
                background-color: var(--main-primary-color);
                color: var(--theme-white-color);
            }

            .draw-mode {
                background-color: var(--main-featured-color);
            }
            .map-new-point__icon {
                padding-bottom: 4px;
            }

            .hideButton {
                display: none;
            }

            .map-draw-options {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                color: var(--theme-input-color);
                width: 100px;
                background-color: var(--theme-border-color);
                border-bottom-right-radius: 8px;
                border: 0;
                gap: 0.5rem;
                padding: 0.5rem;
                box-sizing: border-box;
                overflow: auto;
            }

            .ask-for-shape-type {
                background-color: var(--main-invalid-color);
            }

            .map-draw-options__option {
                width: 100%;
                padding: 0.5rem;
                box-sizing: border-box;
                gap: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: row;
                background: var(--theme-white-color);
                border-radius: 6px;
                font-size: 12px;
                text-align: left;
                cursor: pointer;
            }

            .admin-map-edit-area {
                color: var(--theme-input-color);
                background-color: var(--theme-white-color);
                box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
                border-top-right-radius: 8px;
                border-bottom-right-radius: 8px;
                border: 0;
                padding: 1rem;
                max-height: 50vh;
            }

            .nearby-search-counter {
                background-color: var(--main-invalid-color);
                color: var(--theme-white-color);
                font-weight: bold;
                max-width: 350px;
                padding: 5px;
                border-radius: 8px 8px 0px 0px;
                margin-left: 10px;
                text-align: center;
            }

            .active-drawing {
                font-weight: bold;
                background-color: var(--main-featured-color);
            }

            .map-draw-options__icon {
                cursor: pointer;
                --mdc-icon-size: 14px;
            }

            .draw-info {
                font-size: 10px;
                text-align: center;
            }

            .map-background-style__wrapper {
                width: 35vw;
                background-color: var(--theme-white-color);
                border-radius: 8px;
                margin: 0.25rem;
                padding: 0.5rem;
                z-index: 10;
                box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
                max-height: 45vh;
                display: flex;
            }

            .map-banner-not-subscribed {
                background: var(--main-featured-color);
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 5px;
                text-align: center;
            }

            .map-filter-chips {
                z-index: 3;
            }

            .geo {
                width: 36px;
                height: 36px;
            }

            .hidden {
                display: none;
            }

            #geoImage {
                --mdc-icon-size: 16px;
            }

            #geoImage.activeGeo {
                color: var(--main-success-color);
            }

            .editButtonIcon {
                --mdc-icon-size: 14px;
                margin-right: 0.25rem;
            }

            .editStyleContainer {
                display: flex;
                flex-direction: column;
                position: absolute;
                right: 0.25rem;
                z-index: 2;
                align-items: flex-end;
            }

            .button-text {
                font-size:  12px;
                line-height:1.1;
            }

            .defaultCenterContainer {
                display: flex;
                justify-content: center;
                flex-direction: row;
                position: absolute;
                bottom: 10px;
                width: 100%;
                z-index: 2;
            }

            #mapScreenshotContainer {
                height: 100%;
                width: 100%;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center;
                cursor: pointer;
            }

            button {
                font-family: var(--btn-font-family, var(--main-font, Arial, sans-serif));
            }

            #controlButtons {
                position: absolute;
                z-index: 1;
                bottom: 15px;
                right: 5px;
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                padding: 5px;
                gap: 5px;
            }

            #controlButtons.mobile-above-pagination {
                bottom: 165px; /* Position above mobile pagination area */
            }

            #loadingButtonHolder {
                position: absolute;
                z-index: 10;
                bottom: 40vh;
                right: calc(50% - 75px);
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                padding: 5px;
                gap: 5px;
            }

            #drawingButtons {
                position: absolute;
                z-index: 10;
                top: 10px;
                right: calc(50% - 75px);
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                padding: 5px;
                align-items: center;
                background-color: var(--main-featured-color);
            }

            #drawingButtonsTitle {
                font-size: 12px;
                font-weight: bold;
                color: var(--main-primary-color);
            }

            #geoButton {
                background: none var(--theme-white-color);
                border: 0px;
                text-transform: none;
                appearance: none;
                z-index: 1;
                cursor: pointer;
                user-select: none;
                border-radius: 2px;
                box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
                overflow: hidden;
                height: 30px;
                outline: none;
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 5px;
                color: var(--theme-input-color);
            }

            #loadingButton {
                background: none var(--theme-white-color);
                border: 0px;
                text-transform: none;
                appearance: none;
                z-index: 1;
                cursor: pointer;
                user-select: none;
                border-radius: 2px;
                width: 150px;
                height: 30px;
                box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
                overflow: hidden;
                outline: none;
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 5px;
                color: var(--theme-input-color);
                justify-content: center;
            }

            #zoom-buttons {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 2px;
            }

            .zoomButton {
                background: none var(--theme-white-color);
                border: 0px;
                text-transform: none;
                appearance: none;
                cursor: pointer;
                user-select: none;
                border-radius: 2px;
                height: 30px;
                box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
                overflow: hidden;
                outline: none;
                display: flex;
                flex-direction: row;
                align-items: center;
                color: var(--theme-input-color);
            }


            #poweredBy {
                position: absolute;
                bottom: 0px;
                left: 75px;
                display: flex;
                height: 20px;
                cursor: pointer;
            }

            #proxilink {
                padding-right: 6px;
                padding-left: 6px;
                padding-top: 3px;
                box-sizing: border-box;
                font-family: Roboto, Arial, sans-serif;
                font-size: 10px;
                text-decoration: none;
                vertical-align: middle;
                display: inline-block;
                white-space: nowrap;
            }

            .expand-creator-info-btn-group {
                position: absolute;
                left: 0;
                top: 118px;
                transform: translateX(-100%);
                z-index: 1;
                display: flex;
                flex-direction: column;
                gap: 0.5rem;
                cursor: pointer;
            }

            .expand-creator-info-btn {
                --mdc-icon-button-size: 50px;
                --mdc-icon-size: 30px;
                color: var(--theme-input-color);
                background-color: var(--theme-lightest-color);
                padding: 0.25rem;
                padding-bottom: 0.5rem;
                cursor: pointer;
                display: flex;
                flex-direction: column;
                align-items: center;
                border-radius: 8px 0px 0px 8px;
                min-width: 75px;
            }

            .red {
                background-color: var(--main-invalid-color);
                color: white;
            }

            .green {
                background-color: var(--main-success-color);
                color: white;
            }

            .grey {
                background-color: var(--theme-lightest-color);
                color: var(--theme-input-color);
            }

            .blue {
                background-color: var(--main-secondary-color);
                color: white;
            }

            .expand-creator-info-text {
                font-size: 0.7rem;
                margin: 0;
                padding: 0;
                text-align: center;
                max-width: 75px;
                word-wrap: wrap;
            }

            setting-drawer {
                --bottom-height: 0px;
            }

            .flexContainer {
                display: flex;
                gap: 0.5rem;
            }

            paper-chip.custom-chip {
                --paper-chip-background-color: var(--theme-white-color);
                cursor: pointer;
                pointer-events: all;
                display: flex;
                flex-wrap: nowrap;
                align-items: center;
                margin-top: 8px;
                justify-content: center;
            }

            .interact {
                position: absolute;
                user-select: none;
                width: 100%;
                pointer-events: none;
                box-sizing: border-box;
                -webkit-overflow-scrolling: touch;
                top: 8px;
                z-index: 0;
            }

            .drawingButtonsSubTitle {
                text-align: center;
            }

            @media only screen and (max-width: 550px) {


                .map-filter-chips {
                    z-index: 1;
                }


                .map-drawer {
                    transform: translateY(100%);
                    width: 100%;
                    min-width: unset;
                    left:0;
                    bottom:0;
                    height:unset;
                    max-height:calc(100% - 50px);
                    background-color: transparent;
                    transition: transform 0.3s ease-in-out;
                }

                .inner_desktop_drawer_content {
                    width: 100%;
                }
                .map-drawer.open {
                    transform: translateY(0);
                    border-radius: 0;
                    transition: transform 0.3s ease-in-out;
                    border-left: unset;
                }
                .map-new-point__wrapper {
                    justify-content: flex-end;
                    padding: 12px 0;
                }

                #controlButtons {
                    bottom: 100px;
                }

                #challengeDrawer,
                #challengeUncheckConfirmDrawer,
                #awardAnnouncementDrawer,
                #editShapeDrawer,
                #editGeoJsonDrawer {
                    --bottom-height: 0px;
                    --bottom-height-half: 0px;
                }

                .expand-creator-info-btn {
                    --mdc-icon-button-size: 35px;
                    --mdc-icon-size: 20px;
                }
            }

            .defaultCenterContainer {
                bottom: 10px;
                width: 100%;
                z-index: 1;
            }

        `;
    }

    // set style for interact chip when isInStaticMode is true
    customizeStyles() {
        const chipButtons: any = this?.shadowRoot?.querySelectorAll('paper-chip');
        for (const elem of chipButtons) {
            const chipButton = elem?.shadowRoot?.querySelector('.chip');
            chipButton?.classList.remove('unselectable');

            const chipButtonStyle = elem?.shadowRoot?.querySelector('style');

            chipButtonStyle.innerHTML = `
                .chip {
                    display: flex;
                    flex-direction: row-reverse;
                    height: 32px;
                    font-size: var(--paper-chip-font-size, 13px);
                    font-weight: 500;
                    line-height: 32px;
                    padding: 0 10px;
                    border-radius: 16px;
                    margin-bottom: 5px;
                    margin-right: 5px;
                    animation: glow 1s infinite alternate;
                    background-color: var(--paper-chip-background-color);
                    color: var(--paper-chip-secondary-text-color);
                }

                .chip:hover {
                    box-shadow: 0 0 10px 10px var(--main-featured-color);
                    cursor: pointer;
                }

                @keyframes glow {
                    from {
                        box-shadow: 0 0 10px -10px --var(main-featured-color);
                    }
                    to {
                        box-shadow: 0 0 10px 10px var(--main-featured-color);
                    }
                }

                paper-chip.custom-chip {
                    --paper-chip-background-color: var(--theme-white-color);
                    cursor: pointer;
                    pointer-events: all;
                    display: flex;
                    flex-wrap: nowrap;
                    align-items: center;
                    margin-top: 8px;
                    justify-content: center;
                }
            `;
        }

    }
}


